export const dlsColorBrand = '#0054e6'
export const dlsColorBrand0 = '#fff'
export const dlsColorBrand1 = '#ebf2ff'
export const dlsColorBrand2 = '#dce9ff'
export const dlsColorBrand3 = '#bfd7ff'
export const dlsColorBrand4 = '#95bcff'
export const dlsColorBrand5 = '#5e99ff'
export const dlsColorBrand6 = '#1a6eff'
export const dlsColorBrand7 = '#0054e6'
export const dlsColorBrand8 = '#0047c4'
export const dlsColorBrand9 = '#003796'
export const dlsColorBrand10 = '#00225c'
export const dlsColorBrand11 = '#000'
export const dlsColorInfo = '#0054e6'
export const dlsColorInfo0 = '#fff'
export const dlsColorInfo1 = '#ebf2ff'
export const dlsColorInfo2 = '#dce9ff'
export const dlsColorInfo3 = '#bfd7ff'
export const dlsColorInfo4 = '#95bcff'
export const dlsColorInfo5 = '#5e99ff'
export const dlsColorInfo6 = '#1a6eff'
export const dlsColorInfo7 = '#0054e6'
export const dlsColorInfo8 = '#0047c4'
export const dlsColorInfo9 = '#003796'
export const dlsColorInfo10 = '#00225c'
export const dlsColorInfo11 = '#000'
export const dlsColorSuccess = '#009940'
export const dlsColorSuccess0 = '#fff'
export const dlsColorSuccess1 = '#ebfff3'
export const dlsColorSuccess2 = '#daffe9'
export const dlsColorSuccess3 = '#baffd7'
export const dlsColorSuccess4 = '#8bffbb'
export const dlsColorSuccess5 = '#4dff97'
export const dlsColorSuccess6 = '#00cc55'
export const dlsColorSuccess7 = '#009940'
export const dlsColorSuccess8 = '#008236'
export const dlsColorSuccess9 = '#00632a'
export const dlsColorSuccess10 = '#003d1a'
export const dlsColorSuccess11 = '#000'
export const dlsColorWarning = '#f27318'
export const dlsColorWarning0 = '#fff'
export const dlsColorWarning1 = '#fff3eb'
export const dlsColorWarning2 = '#ffecdf'
export const dlsColorWarning3 = '#ffdfc9'
export const dlsColorWarning4 = '#ffcca8'
export const dlsColorWarning5 = '#ffb37d'
export const dlsColorWarning6 = '#ff9448'
export const dlsColorWarning7 = '#f27318'
export const dlsColorWarning8 = '#ce5600'
export const dlsColorWarning9 = '#9d4200'
export const dlsColorWarning10 = '#612800'
export const dlsColorWarning11 = '#000'
export const dlsColorError = '#d9150b'
export const dlsColorError0 = '#fff'
export const dlsColorError1 = '#ffeceb'
export const dlsColorError2 = '#ffdedc'
export const dlsColorError3 = '#ffc4c0'
export const dlsColorError4 = '#ff9d98'
export const dlsColorError5 = '#ff6a63'
export const dlsColorError6 = '#ff2b20'
export const dlsColorError7 = '#d9150b'
export const dlsColorError8 = '#b80900'
export const dlsColorError9 = '#8d0700'
export const dlsColorError10 = '#570400'
export const dlsColorError11 = '#000'
export const dlsColorGray0 = '#fff'
export const dlsColorGray1 = '#f6f7fa'
export const dlsColorGray2 = '#ebedf5'
export const dlsColorGray3 = '#e2e6f0'
export const dlsColorGray4 = '#d3d9e6'
export const dlsColorGray5 = '#c5ccdb'
export const dlsColorGray6 = '#a8b0bf'
export const dlsColorGray7 = '#848b99'
export const dlsColorGray8 = '#545b66'
export const dlsColorGray9 = '#191b1e'
export const dlsColorGray10 = '#0a0b0d'
export const dlsColorGray11 = '#000'
export const dlsColorTranslucent0 = 'transparent'
export const dlsColorTranslucent1 = 'rgba(109, 159, 247, 0.07)'
export const dlsColorTranslucent2 = 'rgba(108, 156, 240, 0.1)'
export const dlsColorTranslucent3 = 'rgba(102, 146, 222, 0.15)'
export const dlsColorTranslucent4 = 'rgba(96, 134, 199, 0.2)'
export const dlsColorTranslucent5 = 'rgba(90, 119, 168, 0.3)'
export const dlsColorTranslucent6 = 'rgba(83, 101, 138, 0.5)'
export const dlsColorTranslucent7 = 'rgba(73, 86, 107, 0.8)'
export const dlsColorTranslucent8 = 'rgba(46, 52, 64, 0.9)'
export const dlsColorTranslucent9 = 'rgba(13, 15, 18, 0.95)'
export const dlsColorTranslucent10 = 'rgba(4, 4, 5, 0.95)'
export const dlsColorTranslucent11 = '#000'
export const dlsFontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif'
export const dlsFontFamilyNumber = '"Baidu Number", sans-serif'
export const dlsFontSize0 = '12px'
export const dlsFontSize1 = '14px'
export const dlsFontSize2 = '16px'
export const dlsFontSize3 = '18px'
export const dlsFontSize4 = '20px'
export const dlsFontSize5 = '24px'
export const dlsFontSize6 = '32px'
export const dlsFontWeight1 = '400'
export const dlsFontWeight2 = '500'
export const dlsFontWeight3 = '600'
export const dlsLineHeight1 = '1.4'
export const dlsLineHeight2 = '1.6'
export const dlsLineHeight3 = '1.8'
export const dlsSpacingUnit = '4px'
export const dlsPaddingUnit = '4px'
export const dlsHeightUnit = '4px'
export const dlsSpacing1 = '4px'
export const dlsSpacing2 = '8px'
export const dlsSpacing3 = '12px'
export const dlsSpacing4 = '16px'
export const dlsSpacing5 = '24px'
export const dlsSpacing6 = '32px'
export const dlsSpacing7 = '40px'
export const dlsHeightXs = '24px'
export const dlsHeightS = '28px'
export const dlsHeightM = '32px'
export const dlsHeightL = '36px'
export const dlsHeightXl = '40px'
export const dlsForegroundColorReverse = '#fff'
export const dlsForegroundColorPrimaryReverse = '#fff'
export const dlsForegroundColorPrimary = '#0054e6'
export const dlsForegroundColorPrimaryHover = '#1a6eff'
export const dlsForegroundColorPrimaryActive = '#0047c4'
export const dlsForegroundColorPrimaryDisabled = '#95bcff'
export const dlsForegroundColorNeutral = 'rgba(13, 15, 18, 0.95)'
export const dlsForegroundColorNeutralHover = 'rgba(46, 52, 64, 0.9)'
export const dlsForegroundColorNeutralActive = '#000'
export const dlsForegroundColorNeutralDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsForegroundColorNeutralStrong = '#000'
export const dlsForegroundColorNeutralStrongHover = 'rgba(4, 4, 5, 0.95)'
export const dlsForegroundColorNeutralStrongActive = '#000'
export const dlsForegroundColorNeutralStrongDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsForegroundColorNeutralLight = 'rgba(46, 52, 64, 0.9)'
export const dlsForegroundColorNeutralLightHover = 'rgba(73, 86, 107, 0.8)'
export const dlsForegroundColorNeutralLightActive = 'rgba(13, 15, 18, 0.95)'
export const dlsForegroundColorNeutralLightDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsForegroundColorNeutralWeak = 'rgba(73, 86, 107, 0.8)'
export const dlsForegroundColorNeutralWeakHover = 'rgba(46, 52, 64, 0.9)'
export const dlsForegroundColorNeutralWeakActive = 'rgba(13, 15, 18, 0.95)'
export const dlsForegroundColorNeutralWeakDisabled = 'rgba(90, 119, 168, 0.3)'
export const dlsForegroundColorNeutralDim = 'rgba(83, 101, 138, 0.5)'
export const dlsForegroundColorNeutralDimHover = 'rgba(73, 86, 107, 0.8)'
export const dlsForegroundColorNeutralDimActive = 'rgba(46, 52, 64, 0.9)'
export const dlsForegroundColorNeutralDimDisabled = 'rgba(102, 146, 222, 0.15)'
export const dlsForegroundColorNeutralSubtle = 'rgba(90, 119, 168, 0.3)'
export const dlsForegroundColorNeutralSubtleHover = 'rgba(83, 101, 138, 0.5)'
export const dlsForegroundColorNeutralSubtleActive = 'rgba(73, 86, 107, 0.8)'
export const dlsForegroundColorNeutralSubtleDisabled = 'rgba(102, 146, 222, 0.15)'
export const dlsForegroundColorNeutralHighlightable = 'rgba(13, 15, 18, 0.95)'
export const dlsForegroundColorNeutralHighlightableHover = '#1a6eff'
export const dlsForegroundColorNeutralHighlightableActive = '#0047c4'
export const dlsForegroundColorNeutralHighlightableDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsForegroundColorInfoPrimary = '#0054e6'
export const dlsForegroundColorInfoPrimaryDisabled = '#95bcff'
export const dlsForegroundColorSuccessPrimary = '#009940'
export const dlsForegroundColorSuccessPrimaryDisabled = '#8bffbb'
export const dlsForegroundColorWarningPrimary = '#ff9448'
export const dlsForegroundColorWarningPrimaryDisabled = '#ffcca8'
export const dlsForegroundColorErrorPrimary = '#d9150b'
export const dlsForegroundColorErrorPrimaryDisabled = '#ff9d98'
export const dlsForegroundColorHighlighted = '#f27318'
export const dlsBackgroundColorBase1 = '#fff'
export const dlsBackgroundColorBase1Hover = '#f6f7fa'
export const dlsBackgroundColorBase1Active = '#e2e6f0'
export const dlsBackgroundColorBase1Disabled = '#fff'
export const dlsBackgroundColorBase2 = '#f6f7fa'
export const dlsBackgroundColorBase2Hover = '#ebedf5'
export const dlsBackgroundColorBase2Active = '#e2e6f0'
export const dlsBackgroundColorBase2Disabled = '#f6f7fa'
export const dlsBackgroundColorBase3 = '#ebedf5'
export const dlsBackgroundColorBase3Hover = '#e2e6f0'
export const dlsBackgroundColorBase3Active = '#d3d9e6'
export const dlsBackgroundColorBase3Disabled = '#f6f7fa'
export const dlsBackgroundColorPrimary = '#0054e6'
export const dlsBackgroundColorPrimaryHover = '#1a6eff'
export const dlsBackgroundColorPrimaryActive = '#0047c4'
export const dlsBackgroundColorPrimaryDisabled = '#dce9ff'
export const dlsBorderColorPrimary = 'transparent'
export const dlsBorderColorPrimaryDisabled = 'transparent'
export const dlsBackgroundColorInfoPrimary = '#0054e6'
export const dlsBackgroundColorInfoPrimaryHover = '#1a6eff'
export const dlsBackgroundColorInfoPrimaryActive = '#0047c4'
export const dlsBackgroundColorInfoPrimaryDisabled = '#dce9ff'
export const dlsBorderColorInfoPrimary = 'transparent'
export const dlsBorderColorInfoPrimaryDisabled = 'transparent'
export const dlsBackgroundColorSuccessPrimary = '#009940'
export const dlsBackgroundColorSuccessPrimaryHover = '#00cc55'
export const dlsBackgroundColorSuccessPrimaryActive = '#008236'
export const dlsBackgroundColorSuccessPrimaryDisabled = '#daffe9'
export const dlsBorderColorSuccessPrimary = 'transparent'
export const dlsBorderColorSuccessPrimaryDisabled = 'transparent'
export const dlsBackgroundColorWarningPrimary = '#ff9448'
export const dlsBackgroundColorWarningPrimaryHover = '#ffb37d'
export const dlsBackgroundColorWarningPrimaryActive = '#f27318'
export const dlsBackgroundColorWarningPrimaryDisabled = '#ffecdf'
export const dlsBorderColorWarningPrimary = 'transparent'
export const dlsBorderColorWarningPrimaryDisabled = 'transparent'
export const dlsBackgroundColorErrorPrimary = '#d9150b'
export const dlsBackgroundColorErrorPrimaryHover = '#ff2b20'
export const dlsBackgroundColorErrorPrimaryActive = '#b80900'
export const dlsBackgroundColorErrorPrimaryDisabled = '#ffdedc'
export const dlsBorderColorErrorPrimary = 'transparent'
export const dlsBorderColorErrorPrimaryDisabled = 'transparent'
export const dlsBackgroundColorNeutralPrimary = '#a8b0bf'
export const dlsBackgroundColorNeutralPrimaryHover = '#848b99'
export const dlsBackgroundColorNeutralPrimaryActive = '#545b66'
export const dlsBackgroundColorNeutralPrimaryDisabled = '#e2e6f0'
export const dlsBorderColorNeutralPrimary = 'transparent'
export const dlsBorderColorNeutralPrimaryDisabled = 'transparent'
export const dlsBackgroundColorInfo = '#ebf2ff'
export const dlsBackgroundColorInfoHover = '#dce9ff'
export const dlsBackgroundColorInfoActive = '#bfd7ff'
export const dlsBackgroundColorInfoDisabled = '#ebf2ff'
export const dlsBorderColorInfo = '#95bcff'
export const dlsBorderColorInfoDisabled = '#bfd7ff'
export const dlsBackgroundColorSuccess = '#ebfff3'
export const dlsBackgroundColorSuccessHover = '#daffe9'
export const dlsBackgroundColorSuccessActive = '#baffd7'
export const dlsBackgroundColorSuccessDisabled = '#ebfff3'
export const dlsBorderColorSuccess = '#8bffbb'
export const dlsBorderColorSuccessDisabled = '#baffd7'
export const dlsBackgroundColorWarning = '#fff3eb'
export const dlsBackgroundColorWarningHover = '#ffecdf'
export const dlsBackgroundColorWarningActive = '#ffdfc9'
export const dlsBackgroundColorWarningDisabled = '#fff3eb'
export const dlsBorderColorWarning = '#ffcca8'
export const dlsBorderColorWarningDisabled = '#ffdfc9'
export const dlsBackgroundColorError = '#ffeceb'
export const dlsBackgroundColorErrorHover = '#ffdedc'
export const dlsBackgroundColorErrorActive = '#ffc4c0'
export const dlsBackgroundColorErrorDisabled = '#ffeceb'
export const dlsBorderColorError = '#ff9d98'
export const dlsBorderColorErrorDisabled = '#ffc4c0'
export const dlsBackgroundColorNeutral = '#ebedf5'
export const dlsBackgroundColorNeutralHover = '#e2e6f0'
export const dlsBackgroundColorNeutralActive = '#d3d9e6'
export const dlsBackgroundColorNeutralDisabled = '#f6f7fa'
export const dlsBorderColorNeutral = '#c5ccdb'
export const dlsBorderColorNeutralDisabled = '#e2e6f0'
export const dlsBackgroundColorCurrent = '#ebf2ff'
export const dlsBackgroundColorCurrentHover = '#dce9ff'
export const dlsBackgroundColorCurrentActive = '#bfd7ff'
export const dlsBackgroundColorCurrentDisabled = '#ebf2ff'
export const dlsBorderColorCurrent = '#0054e6'
export const dlsBorderColorCurrentDisabled = '#bfd7ff'
export const dlsBackgroundColorStrong = '#fff'
export const dlsBackgroundColorStrongHover = '#ebf2ff'
export const dlsBackgroundColorStrongActive = '#dce9ff'
export const dlsBackgroundColorStrongDisabled = '#ebf2ff'
export const dlsBorderColorStrong = '#0054e6'
export const dlsBorderColorStrongDisabled = '#bfd7ff'
export const dlsBackgroundColorErrorStrong = '#fff'
export const dlsBackgroundColorErrorStrongHover = '#ffeceb'
export const dlsBackgroundColorErrorStrongActive = '#ffdedc'
export const dlsBackgroundColorErrorStrongDisabled = '#ffeceb'
export const dlsBorderColorErrorStrong = '#d9150b'
export const dlsBorderColorErrorStrongDisabled = '#ffc4c0'
export const dlsBackgroundColorFillable = '#fff'
export const dlsBackgroundColorFillableHover = '#ebedf5'
export const dlsBackgroundColorFillableActive = '#d3d9e6'
export const dlsBackgroundColorFillableDisabled = '#f6f7fa'
export const dlsBorderColorFillable = '#d3d9e6'
export const dlsBorderColorFillableHover = '#a8b0bf'
export const dlsBorderColorFillableActive = '#a8b0bf'
export const dlsBorderColorFillableDisabled = '#e2e6f0'
export const dlsBackgroundColorPressable = '#fff'
export const dlsBackgroundColorPressableHover = '#f6f7fa'
export const dlsBackgroundColorPressableActive = '#e2e6f0'
export const dlsBackgroundColorPressableDisabled = '#f6f7fa'
export const dlsBorderColorPressable = '#e2e6f0'
export const dlsBorderColorPressableHover = '#d3d9e6'
export const dlsBorderColorPressableActive = '#d3d9e6'
export const dlsBorderColorPressableDisabled = '#e2e6f0'
export const dlsBackgroundColorTranslucent = 'rgba(0, 0, 0, 0.6)'
export const dlsBackgroundColorTranslucentHover = 'rgba(0, 0, 0, 0.5)'
export const dlsBackgroundColorTranslucentActive = 'rgba(0, 0, 0, 0.7)'
export const dlsBackgroundColorTranslucentDisabled = 'rgba(0, 0, 0, 0.2)'
export const dlsBorderColorTranslucent = 'transparent'
export const dlsBorderColorTranslucentDisabled = 'transparent'
export const dlsBackgroundColorTranslucentReverse = 'transparent'
export const dlsBackgroundColorTranslucentReverseHover = 'rgba(255, 255, 255, 0.15)'
export const dlsBackgroundColorTranslucentReverseActive = 'rgba(255, 255, 255, 0.25)'
export const dlsBackgroundColorTranslucentReverseDisabled = 'transparent'
export const dlsBorderColorTranslucentReverse = 'transparent'
export const dlsBorderColorTranslucentReverseDisabled = 'transparent'
export const dlsBackgroundColorModal = 'rgba(0, 0, 0, 0.6)'
export const dlsLineColor0 = '#ebedf5'
export const dlsLineColor1 = '#e2e6f0'
export const dlsLineColor2 = '#d3d9e6'
export const dlsBorderRadius0 = '2px'
export const dlsBorderRadius1 = '4px'
export const dlsBorderRadius2 = '6px'
export const dlsBorderRadius3 = '10px'
export const dlsBorderRadius4 = '16px'
export const dlsShadowColor = '#000'
export const dlsShadow1 = '0 4px 10px rgba(0, 0, 0, 0.03), 0 3px 9px rgba(0, 0, 0, 0.02), 0 2px 8px rgba(0, 0, 0, 0.01)'
export const dlsShadow2 = '0 6px 28px 2px rgba(0, 0, 0, 0.04), 0 4px 26px 2px rgba(0, 0, 0, 0.03), 0 2px 24px 1px rgba(0, 0, 0, 0.02)'
export const dlsShadow3 = '0 6px 32px 2px rgba(0, 0, 0, 0.06), 0 5px 30px 1px rgba(0, 0, 0, 0.05), 0 4px 28px 1px rgba(0, 0, 0, 0.04)'
export const dlsShadow4 = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsShadowColorLight = '#000'
export const dlsShadowLight1 = '0 4px 10px rgba(0, 0, 0, 0.03), 0 3px 9px rgba(0, 0, 0, 0.02), 0 2px 8px rgba(0, 0, 0, 0.01)'
export const dlsShadowLight2 = '0 6px 28px 2px rgba(0, 0, 0, 0.04), 0 4px 26px 2px rgba(0, 0, 0, 0.03), 0 2px 24px 1px rgba(0, 0, 0, 0.02)'
export const dlsShadowLight3 = '0 6px 32px 2px rgba(0, 0, 0, 0.06), 0 5px 30px 1px rgba(0, 0, 0, 0.05), 0 4px 28px 1px rgba(0, 0, 0, 0.04)'
export const dlsShadowOpacityFocus = '0.2'
export const dlsShadowSpreadFocus = '2px'
export const dlsShadowColorFocus = '#1a6eff'
export const dlsShadowColorErrorFocus = '#ff2b20'
export const dlsShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsShadowErrorFocus = '0 0 0 2px rgba(255, 43, 32, 0.2)'
export const dlsBackgroundColorFocus = '#dce9ff'
export const dlsBorderColorFocus = '#0054e6'
export const dlsBorderColorErrorFocus = '#d9150b'
export const dlsIconSizeNormal = 'calc(1em + 2px)'
export const dlsIconSizeMinor = 'calc(1em + 2px)'
export const dlsIconSizeAux = 'calc(1em + 2px)'
export const dlsIconColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsIconColorAuxDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsTransitionDurationInstant = '100ms'
export const dlsTransitionDurationFast = '200ms'
export const dlsTransitionDurationNormal = '300ms'
export const dlsTransitionDurationSlow = '400ms'
export const dlsTransitionTimingFunctionEase = 'ease'
export const dlsTransitionTimingFunctionEaseIn = 'ease-in'
export const dlsTransitionTimingFunctionEaseOut = 'ease-out'
export const dlsTransitionTimingFunctionLinear = 'linear'
export const dlsButtonFontSizeXs = '12px'
export const dlsButtonFontSizeS = '12px'
export const dlsButtonFontSizeM = '14px'
export const dlsButtonFontSizeL = '16px'
export const dlsButtonFontSizeXl = '16px'
export const dlsButtonHeightXs = '24px'
export const dlsButtonHeightS = '28px'
export const dlsButtonHeightM = '32px'
export const dlsButtonHeightL = '36px'
export const dlsButtonHeightXl = '40px'
export const dlsButtonPaddingXs = '8px'
export const dlsButtonPaddingS = '12px'
export const dlsButtonPaddingM = '16px'
export const dlsButtonPaddingL = '20px'
export const dlsButtonPaddingXl = '20px'
export const dlsButtonBorderRadiusXs = '4px'
export const dlsButtonBorderRadiusS = '4px'
export const dlsButtonBorderRadiusM = '4px'
export const dlsButtonBorderRadiusL = '4px'
export const dlsButtonBorderRadiusXl = '4px'
export const dlsButtonContentSpacing = '4px'
export const dlsButtonFontColorNormal = 'rgba(13, 15, 18, 0.95)'
export const dlsButtonFontColorNormalDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsButtonBorderColorNormal = 'transparent'
export const dlsButtonBorderColorNormalHover = 'transparent'
export const dlsButtonBorderColorNormalActive = 'transparent'
export const dlsButtonBorderColorNormalDisabled = 'transparent'
export const dlsButtonBackgroundColorNormal = '#ebedf5'
export const dlsButtonBackgroundColorNormalHover = '#e2e6f0'
export const dlsButtonBackgroundColorNormalFocus = '#e2e6f0'
export const dlsButtonBackgroundColorNormalActive = '#d3d9e6'
export const dlsButtonBackgroundColorNormalDisabled = '#f6f7fa'
export const dlsButtonFontColorBasic = 'rgba(13, 15, 18, 0.95)'
export const dlsButtonFontColorBasicDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsButtonBorderColorBasic = '#e2e6f0'
export const dlsButtonBorderColorBasicHover = '#d3d9e6'
export const dlsButtonBorderColorBasicActive = '#d3d9e6'
export const dlsButtonBorderColorBasicDisabled = '#e2e6f0'
export const dlsButtonBackgroundColorBasic = '#fff'
export const dlsButtonBackgroundColorBasicHover = '#f6f7fa'
export const dlsButtonBackgroundColorBasicFocus = '#f6f7fa'
export const dlsButtonBackgroundColorBasicActive = '#e2e6f0'
export const dlsButtonBackgroundColorBasicDisabled = '#f6f7fa'
export const dlsButtonFontColorStrong = '#0054e6'
export const dlsButtonFontColorStrongDisabled = '#95bcff'
export const dlsButtonBorderColorStrong = '#0054e6'
export const dlsButtonBorderColorStrongHover = '#0054e6'
export const dlsButtonBorderColorStrongActive = '#0054e6'
export const dlsButtonBorderColorStrongDisabled = '#bfd7ff'
export const dlsButtonBackgroundColorStrong = '#fff'
export const dlsButtonBackgroundColorStrongHover = '#ebf2ff'
export const dlsButtonBackgroundColorStrongFocus = '#ebf2ff'
export const dlsButtonBackgroundColorStrongActive = '#dce9ff'
export const dlsButtonBackgroundColorStrongDisabled = '#ebf2ff'
export const dlsButtonFontColorPrimary = '#fff'
export const dlsButtonFontColorPrimaryDisabled = '#fff'
export const dlsButtonBorderColorPrimary = 'transparent'
export const dlsButtonBorderColorPrimaryHover = 'transparent'
export const dlsButtonBorderColorPrimaryActive = 'transparent'
export const dlsButtonBorderColorPrimaryDisabled = 'transparent'
export const dlsButtonBackgroundColorPrimary = '#0054e6'
export const dlsButtonBackgroundColorPrimaryHover = '#1a6eff'
export const dlsButtonBackgroundColorPrimaryFocus = '#1a6eff'
export const dlsButtonBackgroundColorPrimaryActive = '#0047c4'
export const dlsButtonBackgroundColorPrimaryDisabled = '#dce9ff'
export const dlsButtonFontColorTranslucent = '#fff'
export const dlsButtonFontColorTranslucentDisabled = 'rgba(255, 255, 255, 0.6)'
export const dlsButtonBorderColorTranslucent = 'transparent'
export const dlsButtonBorderColorTranslucentHover = 'transparent'
export const dlsButtonBorderColorTranslucentActive = 'transparent'
export const dlsButtonBorderColorTranslucentDisabled = 'transparent'
export const dlsButtonBackgroundColorTranslucent = 'rgba(0, 0, 0, 0.6)'
export const dlsButtonBackgroundColorTranslucentHover = 'rgba(0, 0, 0, 0.5)'
export const dlsButtonBackgroundColorTranslucentFocus = 'rgba(0, 0, 0, 0.5)'
export const dlsButtonBackgroundColorTranslucentActive = 'rgba(0, 0, 0, 0.7)'
export const dlsButtonBackgroundColorTranslucentDisabled = 'rgba(0, 0, 0, 0.2)'
export const dlsButtonFontColorText = 'rgba(13, 15, 18, 0.95)'
export const dlsButtonFontColorTextHover = 'rgba(46, 52, 64, 0.9)'
export const dlsButtonFontColorTextFocus = 'rgba(13, 15, 18, 0.95)'
export const dlsButtonFontColorTextActive = '#000'
export const dlsButtonFontColorTextDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsButtonFontColorTextStrong = '#0054e6'
export const dlsButtonFontColorTextStrongHover = '#1a6eff'
export const dlsButtonFontColorTextStrongFocus = '#0054e6'
export const dlsButtonFontColorTextStrongActive = '#0047c4'
export const dlsButtonFontColorTextStrongDisabled = '#95bcff'
export const dlsButtonFontColorTextAux = 'rgba(73, 86, 107, 0.8)'
export const dlsButtonFontColorTextAuxHover = 'rgba(46, 52, 64, 0.9)'
export const dlsButtonFontColorTextAuxFocus = 'rgba(73, 86, 107, 0.8)'
export const dlsButtonFontColorTextAuxActive = 'rgba(13, 15, 18, 0.95)'
export const dlsButtonFontColorTextAuxDisabled = 'rgba(90, 119, 168, 0.3)'
export const dlsButtonFontColorTextSubtle = 'rgba(90, 119, 168, 0.3)'
export const dlsButtonFontColorTextSubtleHover = 'rgba(83, 101, 138, 0.5)'
export const dlsButtonFontColorTextSubtleFocus = 'rgba(90, 119, 168, 0.3)'
export const dlsButtonFontColorTextSubtleActive = 'rgba(73, 86, 107, 0.8)'
export const dlsButtonFontColorTextSubtleDisabled = 'rgba(102, 146, 222, 0.15)'
export const dlsButtonBackgroundColorText = 'transparent'
export const dlsButtonBackgroundColorTextHover = 'transparent'
export const dlsButtonBackgroundColorTextFocus = 'transparent'
export const dlsButtonBackgroundColorTextActive = 'transparent'
export const dlsButtonBackgroundColorTextDisabled = 'transparent'
export const dlsButtonPaddingText = '2px'
export const dlsButtonFontColorGhost = 'rgba(13, 15, 18, 0.95)'
export const dlsButtonFontColorGhostDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsButtonBorderColorGhost = 'transparent'
export const dlsButtonBorderColorGhostDisabled = 'transparent'
export const dlsButtonBackgroundColorGhost = 'transparent'
export const dlsButtonBackgroundColorGhostHover = '#f6f7fa'
export const dlsButtonBackgroundColorGhostFocus = '#f6f7fa'
export const dlsButtonBackgroundColorGhostActive = '#e2e6f0'
export const dlsButtonBackgroundColorGhostDisabled = 'transparent'
export const dlsButtonFontColorGhostStrong = '#0054e6'
export const dlsButtonFontColorGhostStrongDisabled = '#95bcff'
export const dlsButtonBorderColorGhostStrong = 'transparent'
export const dlsButtonBorderColorGhostStrongDisabled = 'transparent'
export const dlsButtonBackgroundColorGhostStrong = 'transparent'
export const dlsButtonBackgroundColorGhostStrongHover = '#ebf2ff'
export const dlsButtonBackgroundColorGhostStrongFocus = '#ebf2ff'
export const dlsButtonBackgroundColorGhostStrongActive = '#dce9ff'
export const dlsButtonBackgroundColorGhostStrongDisabled = 'transparent'
export const dlsButtonFontColorGhostAux = 'rgba(73, 86, 107, 0.8)'
export const dlsButtonFontColorGhostAuxDisabled = 'rgba(90, 119, 168, 0.3)'
export const dlsButtonBorderColorGhostAux = 'transparent'
export const dlsButtonBorderColorGhostAuxDisabled = 'transparent'
export const dlsButtonBackgroundColorGhostAux = 'transparent'
export const dlsButtonBackgroundColorGhostAuxHover = '#f6f7fa'
export const dlsButtonBackgroundColorGhostAuxFocus = '#f6f7fa'
export const dlsButtonBackgroundColorGhostAuxActive = '#e2e6f0'
export const dlsButtonBackgroundColorGhostAuxDisabled = 'transparent'
export const dlsButtonFontColorGhostReverse = '#fff'
export const dlsButtonFontColorGhostReverseDisabled = 'rgba(255, 255, 255, 0.5)'
export const dlsButtonBorderColorGhostReverse = 'transparent'
export const dlsButtonBorderColorGhostReverseDisabled = 'transparent'
export const dlsButtonBackgroundColorGhostReverse = 'transparent'
export const dlsButtonBackgroundColorGhostReverseHover = 'rgba(255, 255, 255, 0.15)'
export const dlsButtonBackgroundColorGhostReverseFocus = 'rgba(255, 255, 255, 0.15)'
export const dlsButtonBackgroundColorGhostReverseActive = 'rgba(255, 255, 255, 0.25)'
export const dlsButtonBackgroundColorGhostReverseDisabled = 'transparent'
export const dlsButtonBackgroundColorChecked = '#ebf2ff'
export const dlsButtonBackgroundColorCheckedHover = '#dce9ff'
export const dlsButtonBackgroundColorCheckedFocus = '#dce9ff'
export const dlsButtonBackgroundColorCheckedActive = '#bfd7ff'
export const dlsButtonBackgroundColorCheckedDisabled = '#ebf2ff'
export const dlsButtonBorderColorChecked = '#0054e6'
export const dlsButtonBorderColorCheckedDisabled = '#bfd7ff'
export const dlsButtonForegroundColorChecked = '#0054e6'
export const dlsButtonBorderColorFocus = '#0054e6'
export const dlsButtonShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsButtonGroupSeparatorOpacity = '0.15'
export const dlsButtonFontColorSelected = '#0054e6'
export const dlsButtonFontColorSelectedDisabled = '#95bcff'
export const dlsButtonBorderColorSelected = '#0054e6'
export const dlsButtonBorderColorSelectedDisabled = '#bfd7ff'
export const dlsButtonBackgroundColorSelected = '#ebf2ff'
export const dlsButtonBackgroundColorSelectedHover = '#dce9ff'
export const dlsButtonBackgroundColorSelectedFocus = '#dce9ff'
export const dlsButtonBackgroundColorSelectedActive = '#bfd7ff'
export const dlsButtonBackgroundColorSelectedDisabled = '#ebf2ff'
export const dlsButtonMinWidthStableS = 'calc(24px + 4em)'
export const dlsButtonMinWidthStableM = 'calc(32px + 4em)'
export const dlsLinkFontSizeS = '12px'
export const dlsLinkFontSizeM = '14px'
export const dlsLinkTextDecoration = 'none'
export const dlsLinkTextDecorationHover = 'none'
export const dlsLinkTextDecorationFocus = 'underline'
export const dlsLinkTextDecorationActive = 'none'
export const dlsLinkFontColorNormal = 'rgba(13, 15, 18, 0.95)'
export const dlsLinkFontColorNormalHover = 'rgba(46, 52, 64, 0.9)'
export const dlsLinkFontColorNormalFocus = 'rgba(46, 52, 64, 0.9)'
export const dlsLinkFontColorNormalActive = '#000'
export const dlsLinkFontColorNormalDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsLinkFontColorStrong = '#0054e6'
export const dlsLinkFontColorStrongHover = '#1a6eff'
export const dlsLinkFontColorStrongFocus = '#1a6eff'
export const dlsLinkFontColorStrongActive = '#0047c4'
export const dlsLinkFontColorStrongDisabled = '#95bcff'
export const dlsRadioFontSizeS = '12px'
export const dlsRadioFontSizeM = '14px'
export const dlsRadioFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsRadioFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsRadioSizeS = '14px'
export const dlsRadioSizeM = '16px'
export const dlsRadioDotSizeS = '6px'
export const dlsRadioDotSizeM = '6px'
export const dlsRadioSpacing = '8px'
export const dlsRadioBorderColor = '#d3d9e6'
export const dlsRadioBorderColorHover = '#a8b0bf'
export const dlsRadioBorderColorFocus = '#0054e6'
export const dlsRadioBorderColorActive = '#a8b0bf'
export const dlsRadioBorderColorDisabled = '#e2e6f0'
export const dlsRadioBorderColorChecked = 'transparent'
export const dlsRadioBorderColorCheckedHover = 'transparent'
export const dlsRadioBorderColorCheckedFocus = '#0054e6'
export const dlsRadioBorderColorCheckedActive = 'transparent'
export const dlsRadioBorderColorCheckedDisabled = 'transparent'
export const dlsRadioBackgroundColor = '#fff'
export const dlsRadioBackgroundColorHover = '#ebedf5'
export const dlsRadioBackgroundColorFocus = '#ebedf5'
export const dlsRadioBackgroundColorActive = '#d3d9e6'
export const dlsRadioBackgroundColorDisabled = '#f6f7fa'
export const dlsRadioBackgroundColorChecked = '#0054e6'
export const dlsRadioBackgroundColorCheckedHover = '#1a6eff'
export const dlsRadioBackgroundColorCheckedFocus = '#1a6eff'
export const dlsRadioBackgroundColorCheckedActive = '#0047c4'
export const dlsRadioBackgroundColorCheckedDisabled = '#dce9ff'
export const dlsRadioDotColor = '#fff'
export const dlsRadioDotColorHover = '#fff'
export const dlsRadioDotColorFocus = '#fff'
export const dlsRadioDotColorActive = '#fff'
export const dlsRadioDotColorDisabled = '#fff'
export const dlsRadioShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsRadioGroupSpacing = '24px'
export const dlsRadioGroupSpacingSimple = '8px'
export const dlsRadioGroupLineSpacing = '8px'
export const dlsCheckboxFontSizeS = '12px'
export const dlsCheckboxFontSizeM = '14px'
export const dlsCheckboxFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsCheckboxFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsCheckboxSizeS = '14px'
export const dlsCheckboxSizeM = '16px'
export const dlsCheckboxIconMinSize = '8px'
export const dlsCheckboxIconSize = '1em'
export const dlsCheckboxBorderRadius = '4px'
export const dlsCheckboxSpacing = '8px'
export const dlsCheckboxBorderColor = '#d3d9e6'
export const dlsCheckboxBorderColorHover = '#a8b0bf'
export const dlsCheckboxBorderColorFocus = '#0054e6'
export const dlsCheckboxBorderColorActive = '#a8b0bf'
export const dlsCheckboxBorderColorDisabled = '#e2e6f0'
export const dlsCheckboxBorderColorChecked = 'transparent'
export const dlsCheckboxBorderColorCheckedHover = 'transparent'
export const dlsCheckboxBorderColorCheckedFocus = '#0054e6'
export const dlsCheckboxBorderColorCheckedActive = 'transparent'
export const dlsCheckboxBorderColorCheckedDisabled = 'transparent'
export const dlsCheckboxBackgroundColor = '#fff'
export const dlsCheckboxBackgroundColorHover = '#ebedf5'
export const dlsCheckboxBackgroundColorFocus = '#ebedf5'
export const dlsCheckboxBackgroundColorActive = '#d3d9e6'
export const dlsCheckboxBackgroundColorDisabled = '#f6f7fa'
export const dlsCheckboxBackgroundColorChecked = '#0054e6'
export const dlsCheckboxBackgroundColorCheckedHover = '#1a6eff'
export const dlsCheckboxBackgroundColorCheckedFocus = '#1a6eff'
export const dlsCheckboxBackgroundColorCheckedActive = '#0047c4'
export const dlsCheckboxBackgroundColorCheckedDisabled = '#dce9ff'
export const dlsCheckboxForegroundColor = '#fff'
export const dlsCheckboxForegroundColorHover = '#fff'
export const dlsCheckboxForegroundColorFocus = '#fff'
export const dlsCheckboxForegroundColorActive = '#fff'
export const dlsCheckboxForegroundColorDisabled = '#fff'
export const dlsCheckboxShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsCheckboxGroupSpacing = '24px'
export const dlsCheckboxGroupSpacingSimple = '8px'
export const dlsCheckboxGroupLineSpacing = '8px'
export const dlsCheckboxIconSizeStrong = '6px'
export const dlsCheckboxIconSpacingStrong = '3px'
export const dlsCheckboxIconColorStrong = '#d3d9e6'
export const dlsCheckboxIconColorStrongDisabled = '#e2e6f0'
export const dlsCheckboxIconColorStrongChecked = '#0054e6'
export const dlsCheckboxIconColorStrongCheckedDisabled = '#bfd7ff'
export const dlsSwitchWidthXs = '20px'
export const dlsSwitchWidthS = '26px'
export const dlsSwitchWidthM = '32px'
export const dlsSwitchHeightXs = '12px'
export const dlsSwitchHeightS = '16px'
export const dlsSwitchHeightM = '20px'
export const dlsSwitchThumbSizeXs = '8px'
export const dlsSwitchThumbSizeS = '12px'
export const dlsSwitchThumbSizeM = '14px'
export const dlsSwitchPaddingXs = '2px'
export const dlsSwitchPaddingS = '2px'
export const dlsSwitchPaddingM = '3px'
export const dlsSwitchTrackColorOn = '#0054e6'
export const dlsSwitchTrackColorOnHover = '#1a6eff'
export const dlsSwitchTrackColorOnFocus = '#1a6eff'
export const dlsSwitchTrackColorOnActive = '#0047c4'
export const dlsSwitchTrackColorOnDisabled = '#dce9ff'
export const dlsSwitchTrackColorOff = '#a8b0bf'
export const dlsSwitchTrackColorOffHover = '#848b99'
export const dlsSwitchTrackColorOffFocus = '#848b99'
export const dlsSwitchTrackColorOffActive = '#545b66'
export const dlsSwitchTrackColorOffDisabled = '#e2e6f0'
export const dlsSwitchThumbColorOn = '#fff'
export const dlsSwitchThumbColorOnHover = '#fff'
export const dlsSwitchThumbColorOnFocus = '#fff'
export const dlsSwitchThumbColorOnActive = '#fff'
export const dlsSwitchThumbColorOnDisabled = '#fff'
export const dlsSwitchThumbColorOff = '#fff'
export const dlsSwitchThumbColorOffHover = '#fff'
export const dlsSwitchThumbColorOffFocus = '#fff'
export const dlsSwitchThumbColorOffActive = '#fff'
export const dlsSwitchThumbColorOffDisabled = '#fff'
export const dlsSwitchShadowOnFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsSwitchShadowOffFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsInputFontSizeXs = '12px'
export const dlsInputFontSizeS = '12px'
export const dlsInputFontSizeM = '14px'
export const dlsInputFontSizeL = '16px'
export const dlsInputHeightXs = '24px'
export const dlsInputHeightS = '28px'
export const dlsInputHeightM = '32px'
export const dlsInputHeightL = '36px'
export const dlsInputWidth = '300px'
export const dlsInputBorderRadiusXs = '4px'
export const dlsInputBorderRadiusS = '4px'
export const dlsInputBorderRadiusM = '4px'
export const dlsInputBorderRadiusL = '4px'
export const dlsInputPadding = '12px'
export const dlsInputContentSpacing = '8px'
export const dlsInputBorderColor = '#d3d9e6'
export const dlsInputBorderColorHover = '#a8b0bf'
export const dlsInputBorderColorFocus = '#0054e6'
export const dlsInputBorderColorError = '#d9150b'
export const dlsInputBorderColorErrorHover = '#d9150b'
export const dlsInputBorderColorErrorFocus = '#d9150b'
export const dlsInputBorderColorReadOnly = '#d3d9e6'
export const dlsInputBorderColorReadOnlyHover = '#a8b0bf'
export const dlsInputBorderColorReadOnlyFocus = '#0054e6'
export const dlsInputBorderColorDisabled = '#e2e6f0'
export const dlsInputBackgroundColor = '#fff'
export const dlsInputBackgroundColorReadOnly = '#f6f7fa'
export const dlsInputBackgroundColorDisabled = '#f6f7fa'
export const dlsInputFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsInputFontColorError = 'rgba(13, 15, 18, 0.95)'
export const dlsInputFontColorReadOnly = 'rgba(73, 86, 107, 0.8)'
export const dlsInputFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsInputPlaceholderColor = 'rgba(73, 86, 107, 0.8)'
export const dlsInputCountColor = 'rgba(73, 86, 107, 0.8)'
export const dlsInputCountColorError = '#d9150b'
export const dlsInputShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsInputShadowInlineFocus = '0 1px 0 0 #1a6eff'
export const dlsInputShadowErrorFocus = '0 0 0 2px rgba(255, 43, 32, 0.2)'
export const dlsInputShadowInlineErrorFocus = '0 1px 0 0 #ff2b20'
export const dlsInputIconSize = 'calc(1em + 2px)'
export const dlsInputIconColor = 'rgba(73, 86, 107, 0.8)'
export const dlsInputIconColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsTextareaFontSizeS = '12px'
export const dlsTextareaFontSizeM = '14px'
export const dlsTextareaLineHeight = '1.4'
export const dlsTextareaPaddingX = '12px'
export const dlsTextareaPaddingY = '8px'
export const dlsTextareaWidth = '300px'
export const dlsTextareaRows = '3'
export const dlsTextareaHeightS = '68.4px'
export const dlsTextareaHeightM = '76.8px'
export const dlsTextareaCountHeight = '16px'
export const dlsTextareaCountPadding = '4px'
export const dlsTextareaCountFontSize = '12px'
export const dlsTextareaCountFontColor = '#fff'
export const dlsTextareaCountFontColorError = '#fff'
export const dlsTextareaCountBackgroundColor = 'rgba(0, 0, 0, 0.6)'
export const dlsTextareaCountBackgroundColorError = 'rgba(217, 21, 11, 0.6)'
export const dlsTextareaCountBorderRadius = '4px'
export const dlsNumberInputHeightXs = '24px'
export const dlsNumberInputHeightS = '28px'
export const dlsNumberInputHeightM = '32px'
export const dlsNumberInputSpinIconSizeNormal = '0.85em'
export const dlsNumberInputSpinButtonMinWidthNormal = '18px'
export const dlsNumberInputSpinButtonWidthNormalXs = '18px'
export const dlsNumberInputSpinButtonWidthNormalS = '18px'
export const dlsNumberInputSpinButtonWidthNormalM = '18px'
export const dlsNumberInputDigitsNormal = '6'
export const dlsNumberInputWidthNormalXs = 'calc(6ch + 43px)'
export const dlsNumberInputWidthNormalS = 'calc(6ch + 43px)'
export const dlsNumberInputWidthNormalM = 'calc(6ch + 43px)'
export const dlsNumberInputSpinIconSizeStrong = '1em'
export const dlsNumberInputDigitsStrong = '6'
export const dlsNumberInputWidthStrongXs = 'calc(6ch + 72px)'
export const dlsNumberInputWidthStrongS = 'calc(6ch + 80px)'
export const dlsNumberInputWidthStrongM = 'calc(6ch + 88px)'
export const dlsNumberInputSpinIconColor = 'rgba(73, 86, 107, 0.8)'
export const dlsNumberInputSpinIconColorDisabled = 'rgba(90, 119, 168, 0.3)'
export const dlsOptionFontSizeXs = '12px'
export const dlsOptionFontSizeS = '12px'
export const dlsOptionFontSizeM = '14px'
export const dlsOptionFontSizeL = '16px'
export const dlsOptionHeightXs = '24px'
export const dlsOptionHeightS = '28px'
export const dlsOptionHeightM = '32px'
export const dlsOptionHeightL = '36px'
export const dlsOptionPaddingXs = '16px'
export const dlsOptionPaddingS = '16px'
export const dlsOptionPaddingM = '16px'
export const dlsOptionPaddingL = '16px'
export const dlsOptionMaxWidthXs = 'calc(40em + 32px)'
export const dlsOptionMaxWidthS = 'calc(40em + 32px)'
export const dlsOptionMaxWidthM = 'calc(40em + 32px)'
export const dlsOptionMaxWidthL = 'calc(40em + 32px)'
export const dlsOptionIconSizeAux = 'calc(1em + 2px)'
export const dlsOptionLabelSpacingBefore = '8px'
export const dlsOptionLabelSpacingAfter = '12px'
export const dlsOptionFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsOptionFontColorHover = 'rgba(13, 15, 18, 0.95)'
export const dlsOptionFontColorFocus = 'rgba(13, 15, 18, 0.95)'
export const dlsOptionFontColorActive = 'rgba(13, 15, 18, 0.95)'
export const dlsOptionFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsOptionFontColorHighlighted = '#f27318'
export const dlsOptionIconColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsOptionIconColorAuxDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsOptionFontColorSelected = '#0054e6'
export const dlsOptionFontColorSelectedHover = '#1a6eff'
export const dlsOptionFontColorSelectedFocus = '#1a6eff'
export const dlsOptionFontColorSelectedActive = '#0047c4'
export const dlsOptionBackgroundColor = '#fff'
export const dlsOptionBackgroundColorHover = '#f6f7fa'
export const dlsOptionBackgroundColorFocus = '#dce9ff'
export const dlsOptionBackgroundColorActive = '#e2e6f0'
export const dlsOptionBackgroundColorSelectedParent = '#f6f7fa'
export const dlsOptionFontWeightSelectedParent = '400'
export const dlsOptionFontWeightSelected = '400'
export const dlsOptionGroupLabelLineHeight = '1.4'
export const dlsOptionGroupLabelFontColor = 'rgba(73, 86, 107, 0.8)'
export const dlsOptionGroupLabelPaddingY = '4px'
export const dlsOptionGroupPaddingY = '4px'
export const dlsOptionGroupSeparatorColor = '#e2e6f0'
export const dlsTimePickerWidth = '150px'
export const dlsTimePickerDropdownMinWidth = '150px'
export const dlsTimePickerOptionContentMinWidth = '2ch'
export const dlsTimePickerIconColor = 'rgba(73, 86, 107, 0.8)'
export const dlsTimePickerIconColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsPaginationFontSizeXs = '12px'
export const dlsPaginationFontSizeS = '12px'
export const dlsPaginationFontSizeM = '14px'
export const dlsPaginationPageItemMinWidthXs = '24px'
export const dlsPaginationPageItemMinWidthS = '28px'
export const dlsPaginationPageItemMinWidthM = '32px'
export const dlsPaginationPageItemPaddingX = '4px'
export const dlsPaginationPageItemSpacing = '4px'
export const dlsPaginationPartSpacing = '24px'
export const dlsPaginationContentSpacing = '8px'
export const dlsPaginationGotoInputPaddingX = '8px'
export const dlsPaginationGotoInputDigits = '3'
export const dlsPaginationGotoInputWidth = 'calc(3ch + 18px)'
export const dlsPaginationPageItemFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsPaginationPageItemFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsPaginationPageItemBackgroundColor = '#fff'
export const dlsPaginationPageItemBackgroundColorHover = '#f6f7fa'
export const dlsPaginationPageItemBackgroundColorFocus = '#f6f7fa'
export const dlsPaginationPageItemBackgroundColorActive = '#e2e6f0'
export const dlsPaginationPageItemBackgroundColorDisabled = '#fff'
export const dlsPaginationPageItemFontColorCurrent = '#0054e6'
export const dlsPaginationPageItemBackgroundColorCurrent = '#ebf2ff'
export const dlsPaginationPageItemBackgroundColorCurrentHover = '#dce9ff'
export const dlsPaginationPageItemBackgroundColorCurrentFocus = '#dce9ff'
export const dlsPaginationPageItemBackgroundColorCurrentActive = '#bfd7ff'
export const dlsBadgeFontSize = '12px'
export const dlsBadgeDotSize = '8px'
export const dlsBadgeLabelHeight = '16px'
export const dlsBadgeLabelMinWidth = '16px'
export const dlsBadgeLabelPaddingX = '4px'
export const dlsBadgeLabelSpacingStatus = '8px'
export const dlsBadgeBackgroundColorInfo = '#0054e6'
export const dlsBadgeBackgroundColorSuccess = '#009940'
export const dlsBadgeBackgroundColorWarning = '#ff9448'
export const dlsBadgeBackgroundColorError = '#d9150b'
export const dlsBadgeBackgroundColorAux = '#a8b0bf'
export const dlsBadgeFontColor = '#fff'
export const dlsBreadcrumbFontSizeS = '12px'
export const dlsBreadcrumbFontSizeM = '14px'
export const dlsBreadcrumbSeparatorIconSize = 'calc(1em + 2px)'
export const dlsBreadcrumbSeparatorColor = 'rgba(73, 86, 107, 0.8)'
export const dlsBreadcrumbSeparatorSpacing = '8px'
export const dlsBreadcrumbItemCurrentFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsBreadcrumbItemCurrentFontWeight = '500'
export const dlsStepsTitleFontSizeS = '12px'
export const dlsStepsTitleFontSizeM = '14px'
export const dlsStepsDescFontSizeS = '12px'
export const dlsStepsDescFontSizeM = '12px'
export const dlsStepsMarkerFontSizeS = '16px'
export const dlsStepsMarkerFontSizeM = '16px'
export const dlsStepsTitleFontWeight = '500'
export const dlsStepsTitleFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsStepsTitleFontColorHover = 'rgba(13, 15, 18, 0.95)'
export const dlsStepsTitleFontColorFocus = 'rgba(13, 15, 18, 0.95)'
export const dlsStepsTitleFontColorActive = 'rgba(13, 15, 18, 0.95)'
export const dlsStepsDescFontColor = 'rgba(73, 86, 107, 0.8)'
export const dlsStepsTitleFontColorIncomplete = 'rgba(73, 86, 107, 0.8)'
export const dlsStepsDescFontColorIncomplete = 'rgba(73, 86, 107, 0.8)'
export const dlsStepsMarkerSizeS = '28px'
export const dlsStepsMarkerSizeM = '28px'
export const dlsStepsMarkerSizeDotS = '10px'
export const dlsStepsMarkerSizeDotM = '10px'
export const dlsStepsMarkerRingWidthDotS = '2px'
export const dlsStepsMarkerRingWidthDotM = '2px'
export const dlsStepsMarkerIconSize = '16px'
export const dlsStepsTitleMaxWidth = '10em'
export const dlsStepsDescMaxWidth = '12em'
export const dlsStepsMarkerSpacing = '8px'
export const dlsStepsTitleSpacing = '4px'
export const dlsStepsConnectorSpacingHorizontal = '8px'
export const dlsStepsConnectorSpacingVertical = '8px'
export const dlsStepsConnectorMinLength = '40px'
export const dlsStepsMarkerBackgroundColorIncomplete = '#ebedf5'
export const dlsStepsMarkerBackgroundColorIncompleteHover = '#e2e6f0'
export const dlsStepsMarkerBackgroundColorIncompleteFocus = '#e2e6f0'
export const dlsStepsMarkerBackgroundColorIncompleteActive = '#d3d9e6'
export const dlsStepsMarkerBorderColorIncomplete = 'transparent'
export const dlsStepsMarkerBackgroundColorDotIncomplete = '#a8b0bf'
export const dlsStepsMarkerBackgroundColorDotIncompleteHover = '#848b99'
export const dlsStepsMarkerBackgroundColorDotIncompleteFocus = '#848b99'
export const dlsStepsMarkerBackgroundColorDotIncompleteActive = '#545b66'
export const dlsStepsMarkerBorderColorDotIncomplete = 'transparent'
export const dlsStepsMarkerForegroundColorIncomplete = 'rgba(73, 86, 107, 0.8)'
export const dlsStepsConnectorColorIncomplete = '#d3d9e6'
export const dlsStepsMarkerBackgroundColorCompleted = '#ebf2ff'
export const dlsStepsMarkerBackgroundColorCompletedHover = '#dce9ff'
export const dlsStepsMarkerBackgroundColorCompletedFocus = '#dce9ff'
export const dlsStepsMarkerBackgroundColorCompletedActive = '#bfd7ff'
export const dlsStepsMarkerBorderColorCompleted = 'transparent'
export const dlsStepsMarkerBackgroundColorDotCompleted = '#0054e6'
export const dlsStepsMarkerBackgroundColorDotCompletedHover = '#1a6eff'
export const dlsStepsMarkerBackgroundColorDotCompletedFocus = '#1a6eff'
export const dlsStepsMarkerBackgroundColorDotCompletedActive = '#0047c4'
export const dlsStepsMarkerBorderColorDotCompleted = 'transparent'
export const dlsStepsMarkerForegroundColorCompleted = '#0054e6'
export const dlsStepsConnectorColorCompleted = '#0054e6'
export const dlsStepsMarkerBackgroundColorError = '#ffeceb'
export const dlsStepsMarkerBackgroundColorErrorHover = '#ffdedc'
export const dlsStepsMarkerBackgroundColorErrorFocus = '#ffdedc'
export const dlsStepsMarkerBackgroundColorErrorActive = '#ffc4c0'
export const dlsStepsMarkerBorderColorError = 'transparent'
export const dlsStepsMarkerBackgroundColorDotError = '#d9150b'
export const dlsStepsMarkerBackgroundColorDotErrorHover = '#ff2b20'
export const dlsStepsMarkerBackgroundColorDotErrorFocus = '#ff2b20'
export const dlsStepsMarkerBackgroundColorDotErrorActive = '#b80900'
export const dlsStepsMarkerBorderColorDotError = 'transparent'
export const dlsStepsMarkerForegroundColorError = '#d9150b'
export const dlsStepsConnectorColorError = '#d9150b'
export const dlsStepsMarkerBackgroundColorCurrent = '#0054e6'
export const dlsStepsMarkerBackgroundColorCurrentHover = '#1a6eff'
export const dlsStepsMarkerBackgroundColorCurrentFocus = '#1a6eff'
export const dlsStepsMarkerBackgroundColorCurrentActive = '#0047c4'
export const dlsStepsMarkerBorderColorCurrent = 'transparent'
export const dlsStepsMarkerBackgroundColorDotCurrent = '#0054e6'
export const dlsStepsMarkerBackgroundColorDotCurrentHover = '#1a6eff'
export const dlsStepsMarkerBackgroundColorDotCurrentFocus = '#1a6eff'
export const dlsStepsMarkerBackgroundColorDotCurrentActive = '#0047c4'
export const dlsStepsMarkerBorderColorDotCurrent = 'transparent'
export const dlsStepsMarkerForegroundColorCurrent = '#fff'
export const dlsStepsConnectorColorCurrent = '#0054e6'
export const dlsStepsMarkerBackgroundColorErrorCurrent = '#d9150b'
export const dlsStepsMarkerBackgroundColorErrorCurrentHover = '#ff2b20'
export const dlsStepsMarkerBackgroundColorErrorCurrentFocus = '#ff2b20'
export const dlsStepsMarkerBackgroundColorErrorCurrentActive = '#b80900'
export const dlsStepsMarkerBorderColorErrorCurrent = 'transparent'
export const dlsStepsMarkerBackgroundColorDotErrorCurrent = '#d9150b'
export const dlsStepsMarkerBackgroundColorDotErrorCurrentHover = '#ff2b20'
export const dlsStepsMarkerBackgroundColorDotErrorCurrentFocus = '#ff2b20'
export const dlsStepsMarkerBackgroundColorDotErrorCurrentActive = '#b80900'
export const dlsStepsMarkerBorderColorDotErrorCurrent = 'transparent'
export const dlsStepsMarkerForegroundColorErrorCurrent = '#fff'
export const dlsStepsConnectorColorErrorCurrent = '#d9150b'
export const dlsStepsMarkerBackgroundColorStateless = '#ebf2ff'
export const dlsStepsMarkerBorderColorStateless = 'transparent'
export const dlsStepsMarkerBackgroundColorDotStateless = '#0054e6'
export const dlsStepsMarkerBorderColorDotStateless = 'transparent'
export const dlsStepsMarkerForegroundColorStateless = '#0054e6'
export const dlsStepsConnectorColorStateless = '#d3d9e6'
export const dlsStepsMarkerBorderColorFocus = '#0054e6'
export const dlsStepsMarkerBorderColorErrorFocus = '#d9150b'
export const dlsStepsMarkerShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsStepsMarkerShadowErrorFocus = '0 0 0 2px rgba(255, 43, 32, 0.2)'
export const dlsTagHeightS = '24px'
export const dlsTagHeightM = '28px'
export const dlsTagBorderRadiusS = '4px'
export const dlsTagBorderRadiusM = '4px'
export const dlsTagPadding = '8px'
export const dlsTagContentSpacing = '8px'
export const dlsTagListSpacing = '4px'
export const dlsTagFontSizeS = '12px'
export const dlsTagFontSizeM = '14px'
export const dlsTagIconSizeAux = 'calc(1em - 2px)'
export const dlsTagColor = 'rgba(46, 52, 64, 0.9)'
export const dlsTagColorSelected = '#0054e6'
export const dlsTagColorDefault = '#848b99'
export const dlsTagColorDefaultSelected = '#0054e6'
export const dlsTagColorInfo = '#0054e6'
export const dlsTagColorSuccess = '#009940'
export const dlsTagColorWarning = '#ff9448'
export const dlsTagColorError = '#d9150b'
export const dlsTagFontColorDefault = 'rgba(13, 15, 18, 0.95)'
export const dlsTagFontColorSelected = '#fff'
export const dlsTagFontColorReverse = '#fff'
export const dlsTagColorTurquoise = '#4db2b2'
export const dlsTagColorViolet = '#5e1ae5'
export const dlsTagColorGreen = '#4bac3a'
export const dlsTagFontOpacityDisabled = '0.3'
export const dlsTagFontOpacitySelectedDisabled = '1'
export const dlsTagFontOpacityReverseDisabled = '1'
export const dlsTagBackgroundOpacity = '0.08'
export const dlsTagBackgroundOpacityHover = '0.2'
export const dlsTagBackgroundOpacityActive = '0.3'
export const dlsTagBackgroundOpacityDisabled = '0.1'
export const dlsTagBackgroundOpacitySelected = '1'
export const dlsTagBackgroundOpacitySelectedHover = '0.6'
export const dlsTagBackgroundOpacitySelectedActive = '0.8'
export const dlsTagBackgroundOpacitySelectedDisabled = '0.1'
export const dlsTagBackgroundOpacityReverse = '1'
export const dlsTagBackgroundOpacityReverseHover = '0.6'
export const dlsTagBackgroundOpacityReverseActive = '0.8'
export const dlsTagBackgroundOpacityReverseDisabled = '0.1'
export const dlsTagBorderOpacity = '0.1'
export const dlsTagBorderOpacityDisabled = '0.1'
export const dlsAnchorPaddingX = '16px'
export const dlsAnchorItemSpacing = '12px'
export const dlsAnchorLevelIndent = '16px'
export const dlsAnchorTrackColor = '#e2e6f0'
export const dlsAnchorTrackWidth = '1px'
export const dlsAnchorIndicatorWidth = '2px'
export const dlsAnchorIndicatorColor = '#0054e6'
export const dlsAnchorIndicatorColorHover = '#1a6eff'
export const dlsAnchorIndicatorColorFocus = '#1a6eff'
export const dlsAnchorIndicatorColorActive = '#0047c4'
export const dlsLoadingFontSizeS = '12px'
export const dlsLoadingFontSizeM = '14px'
export const dlsLoadingFontSizeL = '16px'
export const dlsLoadingLineHeight = '1.4'
export const dlsLoadingSizeS = 'calc(1em + 2px)'
export const dlsLoadingSizeM = 'calc(1em + 2px)'
export const dlsLoadingSizeL = '24px'
export const dlsLoadingContentSpacingS = '4px'
export const dlsLoadingContentSpacingM = '4px'
export const dlsLoadingContentSpacingL = '8px'
export const dlsLoadingFontColorNormal = 'rgba(13, 15, 18, 0.95)'
export const dlsLoadingFontColorStrong = 'rgba(13, 15, 18, 0.95)'
export const dlsLoadingFontColorReverse = '#fff'
export const dlsLoadingColorNormal = 'rgba(73, 86, 107, 0.8)'
export const dlsLoadingColorStrong = '#0054e6'
export const dlsLoadingColorReverse = '#fff'
export const dlsLoadingBackgroundColor = 'rgba(255, 255, 255, 0.8)'
export const dlsLoadingBackgroundColorReverse = 'rgba(0, 0, 0, 0.6)'
export const dlsProgressWidthBarXs = '160px'
export const dlsProgressWidthBarS = '200px'
export const dlsProgressWidthBarM = '300px'
export const dlsProgressSizeCircularXs = '60px'
export const dlsProgressSizeCircularS = '80px'
export const dlsProgressSizeCircularM = '100px'
export const dlsProgressFontSizeXs = '12px'
export const dlsProgressFontSizeS = '12px'
export const dlsProgressFontSizeM = '14px'
export const dlsProgressFontSizeCircularXs = '12px'
export const dlsProgressFontSizeCircularS = '14px'
export const dlsProgressFontSizeCircularM = '16px'
export const dlsProgressFontColor = 'rgba(46, 52, 64, 0.9)'
export const dlsProgressIconSizeBar = 'calc(1em + 2px)'
export const dlsProgressIconSizeCircularXs = '16px'
export const dlsProgressIconSizeCircularS = '24px'
export const dlsProgressIconSizeCircularM = '32px'
export const dlsProgressTrackWidthXs = '2px'
export const dlsProgressTrackWidthS = '4px'
export const dlsProgressTrackWidthM = '6px'
export const dlsProgressBorderRadiusXs = '1px'
export const dlsProgressBorderRadiusS = '2px'
export const dlsProgressBorderRadiusM = '3px'
export const dlsProgressTrackSpacingBar = '8px'
export const dlsProgressIconSpacingBar = '8px'
export const dlsProgressTrackColor = '#d3d9e6'
export const dlsProgressIndicatorColor = '#0054e6'
export const dlsProgressIndicatorColorSuccess = '#009940'
export const dlsProgressIndicatorColorError = '#d9150b'
export const dlsProgressIconColorSuccess = '#009940'
export const dlsProgressIconColorError = '#d9150b'
export const dlsTreeNodeHeightS = '28px'
export const dlsTreeNodeHeightM = '32px'
export const dlsTreeFontSizeS = '12px'
export const dlsTreeFontSizeM = '14px'
export const dlsTreeIconSize = 'calc(1em + 2px)'
export const dlsTreeIconSizeAux = 'calc(1em + 2px)'
export const dlsTreePaddingX = '16px'
export const dlsTreeNodeContentSpacing = '8px'
export const dlsTreeIconColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsTreeIconColorAuxDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsTreeNodeFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsTreeNodeFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsTreeNodeFontColorSelected = '#0054e6'
export const dlsTreeNodeFontColorSelectedHover = '#1a6eff'
export const dlsTreeNodeFontColorSelectedFocus = '#1a6eff'
export const dlsTreeNodeFontColorSelectedActive = '#0047c4'
export const dlsTreeNodeFontColorHighlighted = '#f27318'
export const dlsTreeNodeBackgroundColor = '#fff'
export const dlsTreeNodeBackgroundColorHover = '#f6f7fa'
export const dlsTreeNodeBackgroundColorFocus = '#f6f7fa'
export const dlsTreeNodeBackgroundColorActive = '#e2e6f0'
export const dlsTreeNodeBackgroundColorSelected = '#ebf2ff'
export const dlsTreeNodeBackgroundColorSelectedHover = '#dce9ff'
export const dlsTreeNodeBackgroundColorSelectedFocus = '#dce9ff'
export const dlsTreeNodeBackgroundColorSelectedActive = '#bfd7ff'
export const dlsTreeNodeFontWeightSelected = '400'
export const dlsTransferFontSizeS = '12px'
export const dlsTransferFontSizeM = '14px'
export const dlsTransferBorderRadiusS = '4px'
export const dlsTransferBorderRadiusM = '4px'
export const dlsTransferPaddingX = '12px'
export const dlsTransferHeaderContentSpacing1 = '4px'
export const dlsTransferHeaderContentSpacing2 = '8px'
export const dlsTransferContentPaddingY = '4px'
export const dlsTransferItemHeightS = '28px'
export const dlsTransferItemHeightM = '32px'
export const dlsTransferItemContentSpacing = '8px'
export const dlsTransferContentMinHeightS = '288px'
export const dlsTransferContentMinHeightM = '328px'
export const dlsTransferPanelWidthS = '228px'
export const dlsTransferPanelWidthM = '260px'
export const dlsTransferPanelSpacing = '12px'
export const dlsTransferHeaderHeightS = '32px'
export const dlsTransferHeaderHeightM = '36px'
export const dlsTransferHeaderBackgroundColor = '#f6f7fa'
export const dlsTransferHeaderFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsTransferHeaderFontWeight = '400'
export const dlsTransferHeaderButtonFontWeight = '500'
export const dlsTransferBorderColor = '#d3d9e6'
export const dlsTransferItemBackgroundColor = '#fff'
export const dlsTransferItemBackgroundColorHover = '#f6f7fa'
export const dlsTransferItemBackgroundColorFocus = '#f6f7fa'
export const dlsTransferItemBackgroundColorActive = '#e2e6f0'
export const dlsTransferItemBackgroundColorDisabled = 'transparent'
export const dlsTransferItemFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsTransferItemFontColorHover = 'rgba(13, 15, 18, 0.95)'
export const dlsTransferItemFontColorFocus = 'rgba(13, 15, 18, 0.95)'
export const dlsTransferItemFontColorActive = 'rgba(13, 15, 18, 0.95)'
export const dlsTransferItemFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsTabHeightS = '40px'
export const dlsTabHeightM = '44px'
export const dlsTabHeightL = '48px'
export const dlsTabMaxWidthNormalS = 'calc(10em + 12px)'
export const dlsTabMaxWidthNormalM = 'calc(10em + 12px)'
export const dlsTabMaxWidthNormalL = 'calc(10em + 12px)'
export const dlsTabMaxWidthSimpleS = 'calc(10em + 12px)'
export const dlsTabMaxWidthSimpleM = 'calc(10em + 12px)'
export const dlsTabMaxWidthSimpleL = 'calc(10em + 12px)'
export const dlsTabMaxWidthStrongM = 'calc(10em + 60px)'
export const dlsTabMinWidthNormalS = '2em'
export const dlsTabMinWidthNormalM = '2em'
export const dlsTabMinWidthNormalL = '2em'
export const dlsTabMinWidthSimpleS = '2em'
export const dlsTabMinWidthSimpleM = '2em'
export const dlsTabMinWidthSimpleL = '2em'
export const dlsTabPaddingNormalS = '0'
export const dlsTabPaddingNormalM = '0'
export const dlsTabPaddingNormalL = '0'
export const dlsTabPaddingSimpleS = '0'
export const dlsTabPaddingSimpleM = '0'
export const dlsTabPaddingSimpleL = '0'
export const dlsTabPaddingStrongM = '24px'
export const dlsTabSpacingNormalS = '24px'
export const dlsTabSpacingNormalM = '32px'
export const dlsTabSpacingNormalL = '48px'
export const dlsTabSpacingSimpleS = '32px'
export const dlsTabSpacingSimpleM = '40px'
export const dlsTabSpacingSimpleL = '48px'
export const dlsTabSpacingStrongM = '0'
export const dlsTabMenuPaddingNormal = 'var(--dls-tab-menu-spacing-around)'
export const dlsTabContentSpacing = '4px'
export const dlsTabRemoveSpacing = '2px'
export const dlsTabNavSpacingNormalS = '12px'
export const dlsTabNavSpacingNormalM = '16px'
export const dlsTabNavSpacingNormalL = '24px'
export const dlsTabNavSpacingSimpleS = '16px'
export const dlsTabNavSpacingSimpleM = '20px'
export const dlsTabNavSpacingSimpleL = '24px'
export const dlsTabNavSpacingStrongM = '12px'
export const dlsTabFontSizeS = '12px'
export const dlsTabFontSizeM = '14px'
export const dlsTabFontSizeL = '16px'
export const dlsTabFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsTabFontColorHover = 'rgba(46, 52, 64, 0.9)'
export const dlsTabFontColorFocus = 'rgba(46, 52, 64, 0.9)'
export const dlsTabFontColorActive = '#000'
export const dlsTabFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsTabFontColorCurrent = '#0054e6'
export const dlsTabFontColorCurrentHover = '#1a6eff'
export const dlsTabFontColorCurrentFocus = '#1a6eff'
export const dlsTabFontColorCurrentActive = '#0047c4'
export const dlsTabBackgroundColorFocus = '#dce9ff'
export const dlsTabFontWeightCurrent = '400'
export const dlsTabContainerSeparatorColor = '#d3d9e6'
export const dlsTabContainerBorderWidth = '1px'
export const dlsTabPanelPaddingTop = '16px'
export const dlsTabOverflowShadowRight = '0 6px 28px 2px rgba(0, 0, 0, 0.04), 0 4px 26px 2px rgba(0, 0, 0, 0.03), 0 2px 24px 1px rgba(0, 0, 0, 0.02)'
export const dlsTabOverflowShadowLeft = '0 6px 28px 2px rgba(0, 0, 0, 0.04), 0 4px 26px 2px rgba(0, 0, 0, 0.03), 0 2px 24px 1px rgba(0, 0, 0, 0.02)'
export const dlsTabIndicatorColor = '#0054e6'
export const dlsTabIndicatorWidth = '2px'
export const dlsTabIconSize = 'calc(1em + 2px)'
export const dlsTabIconSizeAux = 'calc(1em - 2px)'
export const dlsTabSeparatorHeightSimple = '1em'
export const dlsTabSeparatorColor = '#d3d9e6'
export const dlsTabMenuHeightStrongM = '48px'
export const dlsTabNavSpacingExtraStrongM = '24px'
export const dlsTabMenuPaddingStrongM = '16px'
export const dlsTabBorderRadiusStrongM = '10px'
export const dlsTabContainerBorderRadiusStrongM = '6px'
export const dlsTabContainerBorderColorStrong = '#ebedf5'
export const dlsTabMenuBackgroundColorStrong = '#ebedf5'
export const dlsTabBackgroundColorStrong = 'transparent'
export const dlsTabBackgroundColorStrongHover = '#f6f7fa'
export const dlsTabBackgroundColorStrongFocus = '#dce9ff'
export const dlsTabBackgroundColorStrongActive = '#e2e6f0'
export const dlsTabBackgroundColorStrongDisabled = 'transparent'
export const dlsTabBackgroundColorStrongCurrent = '#fff'
export const dlsTabBackgroundColorStrongCurrentHover = '#fff'
export const dlsTabBackgroundColorStrongCurrentFocus = '#fff'
export const dlsTabBackgroundColorStrongCurrentActive = '#fff'
export const dlsTabFontColorStrong = 'rgba(13, 15, 18, 0.95)'
export const dlsTabFontColorStrongHover = 'rgba(46, 52, 64, 0.9)'
export const dlsTabFontColorStrongFocus = 'rgba(46, 52, 64, 0.9)'
export const dlsTabFontColorStrongActive = '#000'
export const dlsTabFontColorStrongDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsTabFontColorStrongCurrent = '#0054e6'
export const dlsTabFontColorStrongCurrentHover = '#1a6eff'
export const dlsTabFontColorStrongCurrentFocus = '#1a6eff'
export const dlsTabFontColorStrongCurrentActive = '#0047c4'
export const dlsMenuItemFontWeightCurrent = '400'
export const dlsMenuItemIconColor = 'rgba(73, 86, 107, 0.8)'
export const dlsMenuItemIconColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsMenuItemIconColorCurrent = 'currentColor'
export const dlsMenuItemIconColorCurrentDisabled = 'currentColor'
export const dlsMenuIndicatorWidth = '2px'
export const dlsMenuIndicatorColor = '#0054e6'
export const dlsMenuIndicatorColorHover = '#0054e6'
export const dlsMenuIndicatorColorFocus = '#0054e6'
export const dlsMenuIndicatorColorActive = '#0054e6'
export const dlsMenuWidth = '200px'
export const dlsMenuWidthCollapsed = '60px'
export const dlsMenuFontSizeS = '12px'
export const dlsMenuFontSizeM = '14px'
export const dlsMenuFontSizeL = '16px'
export const dlsMenuItemHeightS = '28px'
export const dlsMenuItemHeightM = '32px'
export const dlsMenuItemHeightL = '36px'
export const dlsMenuPaddingX = '20px'
export const dlsMenuPaddingY = '8px'
export const dlsMenuItemSpacing = '8px'
export const dlsMenuItemContentSpacing = '12px'
export const dlsMenuLevelIndent = '16px'
export const dlsMenuFooterHeightS = '28px'
export const dlsMenuFooterHeightM = '28px'
export const dlsMenuFooterHeightL = '28px'
export const dlsMenuItemIconSize = 'calc(1em + 2px)'
export const dlsMenuItemIconSizeAux = 'calc(1em + 2px)'
export const dlsMenuBorderColor = '#e2e6f0'
export const dlsMenuSeparatorColor = '#e2e6f0'
export const dlsMenuItemFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsMenuItemFontColorHover = 'rgba(13, 15, 18, 0.95)'
export const dlsMenuItemFontColorFocus = 'rgba(13, 15, 18, 0.95)'
export const dlsMenuItemFontColorActive = 'rgba(13, 15, 18, 0.95)'
export const dlsMenuItemFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsMenuItemBackgroundColor = '#fff'
export const dlsMenuItemBackgroundColorHover = '#f6f7fa'
export const dlsMenuItemBackgroundColorFocus = '#dce9ff'
export const dlsMenuItemBackgroundColorActive = '#e2e6f0'
export const dlsMenuItemBackgroundColorDisabled = '#fff'
export const dlsMenuItemFontColorCurrent = '#0054e6'
export const dlsMenuItemFontColorCurrentHover = '#1a6eff'
export const dlsMenuItemFontColorCurrentFocus = '#1a6eff'
export const dlsMenuItemFontColorCurrentActive = '#0047c4'
export const dlsMenuItemBackgroundColorCurrent = '#ebf2ff'
export const dlsMenuItemBackgroundColorCurrentHover = '#dce9ff'
export const dlsMenuItemBackgroundColorCurrentFocus = '#dce9ff'
export const dlsMenuItemBackgroundColorCurrentActive = '#bfd7ff'
export const dlsMenuItemGroupLabelFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsMenuItemGroupLabelFontWeight = '500'
export const dlsMenuFontSizeHorizontalM = '14px'
export const dlsMenuItemHeightHorizontalM = '64px'
export const dlsMenuItemPaddingXHorizontal = '16px'
export const dlsMenuBorderColorHorizontal = '#d3d9e6'
export const dlsMenuItemFontColorHorizontal = 'rgba(13, 15, 18, 0.95)'
export const dlsMenuItemFontColorHorizontalHover = 'rgba(46, 52, 64, 0.9)'
export const dlsMenuItemFontColorHorizontalFocus = 'rgba(46, 52, 64, 0.9)'
export const dlsMenuItemFontColorHorizontalActive = '#000'
export const dlsMenuItemFontColorHorizontalDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsMenuItemBackgroundColorHorizontal = '#fff'
export const dlsMenuItemBackgroundColorHorizontalHover = '#fff'
export const dlsMenuItemBackgroundColorHorizontalFocus = '#dce9ff'
export const dlsMenuItemBackgroundColorHorizontalActive = '#fff'
export const dlsMenuItemBackgroundColorHorizontalDisabled = '#fff'
export const dlsMenuItemFontColorHorizontalCurrent = '#0054e6'
export const dlsMenuItemFontColorHorizontalCurrentHover = '#1a6eff'
export const dlsMenuItemFontColorHorizontalCurrentFocus = '#1a6eff'
export const dlsMenuItemFontColorHorizontalCurrentActive = '#0047c4'
export const dlsMenuItemBackgroundColorHorizontalCurrent = '#fff'
export const dlsMenuItemBackgroundColorHorizontalCurrentHover = '#fff'
export const dlsMenuItemBackgroundColorHorizontalCurrentFocus = '#dce9ff'
export const dlsMenuItemBackgroundColorHorizontalCurrentActive = '#fff'
export const dlsMenuItemShadowHorizontalCurrent = '0 1px 2px rgba(0, 84, 230, 0.4)'
export const dlsMenuCardBackgroundColor = '#fff'
export const dlsMenuCardBorderRadiusM = '4px'
export const dlsMenuCardPaddingX = '24px'
export const dlsMenuCardPaddingY = '24px'
export const dlsMenuCardColumnSpacing = '48px'
export const dlsMenuCardTargetSpacing = '4px'
export const dlsMenuCardTitleFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsMenuCardTitleFontSizeM = '14px'
export const dlsMenuCardTitleFontWeight = '500'
export const dlsMenuCardItemSpacing = '16px'
export const dlsMenuCardItemFontSizeM = '14px'
export const dlsMenuCardItemIconSize = 'calc(1em + 2px)'
export const dlsNavItemFontSize = '14px'
export const dlsNavItemHeight = '64px'
export const dlsNavItemPadding = '0'
export const dlsNavItemPaddingMore = '8px'
export const dlsNavItemSpacing = '32px'
export const dlsNavItemContentSpacing = '4px'
export const dlsNavItemIconSizeAux = 'calc(1em + 2px)'
export const dlsNavItemFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsNavItemFontColorHover = '#1a6eff'
export const dlsNavItemFontColorFocus = '#1a6eff'
export const dlsNavItemFontColorActive = '#0047c4'
export const dlsNavItemFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsNavItemFontColorCurrent = '#0054e6'
export const dlsNavItemFontColorCurrentHover = '#1a6eff'
export const dlsNavItemFontColorCurrentFocus = '#1a6eff'
export const dlsNavItemFontColorCurrentActive = '#0047c4'
export const dlsNavItemBackgroundColorFocus = '#dce9ff'
export const dlsNavItemIconColorAux = 'currentColor'
export const dlsNavItemIconColorAuxDisabled = 'currentColor'
export const dlsNavItemIconColorAuxCurrent = 'currentColor'
export const dlsNavIndicatorStrokeWidth = '3px'
export const dlsNavIndicatorBorderRadius = '14px'
export const dlsNavIndicatorWidth = '28px'
export const dlsNavIndicatorWidthHover = '12px'
export const dlsNavIndicatorWidthFocus = '12px'
export const dlsNavIndicatorWidthActive = '36px'
export const dlsNavIndicatorColor = '#0054e6'
export const dlsNavIndicatorColorHover = '#0054e6'
export const dlsNavIndicatorColorFocus = '#0054e6'
export const dlsNavIndicatorColorActive = '#0054e6'
export const dlsNavCardBackgroundColor = '#fff'
export const dlsNavCardBorderRadius = '4px'
export const dlsNavCardPadding = '24px'
export const dlsNavCardColumnSpacing = '48px'
export const dlsNavCardTargetSpacing = '4px'
export const dlsNavCardTitleFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsNavCardTitleFontSize = '14px'
export const dlsNavCardTitleFontWeight = '500'
export const dlsNavCardItemSpacing = '16px'
export const dlsNavCardItemFontSize = '14px'
export const dlsNavCardItemIconSize = 'calc(1em + 2px)'
export const dlsSidenavItemHeight = '32px'
export const dlsSidenavPaddingX = '8px'
export const dlsSidenavPaddingY = '8px'
export const dlsSidenavItemPaddingStart = '24px'
export const dlsSidenavItemPaddingEnd = '16px'
export const dlsSidenavItemLevelIndent = '16px'
export const dlsSidenavItemSpacing = '8px'
export const dlsSidenavItemContentSpacing = '8px'
export const dlsSidenavItemIconSize = 'calc(1em + 2px)'
export const dlsSidenavItemIconSizeAux = 'calc(1em + 2px)'
export const dlsSidenavItemFontSize = '14px'
export const dlsSidenavItemGroupFontWeight = '500'
export const dlsSidenavItemFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsSidenavItemFontColorHover = 'rgba(46, 52, 64, 0.9)'
export const dlsSidenavItemFontColorFocus = 'rgba(46, 52, 64, 0.9)'
export const dlsSidenavItemFontColorActive = '#000'
export const dlsSidenavItemFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsSidenavItemFontColorCurrent = '#0054e6'
export const dlsSidenavItemFontColorCurrentHover = '#1a6eff'
export const dlsSidenavItemFontColorCurrentFocus = '#1a6eff'
export const dlsSidenavItemFontColorCurrentActive = '#0047c4'
export const dlsSidenavItemIconColor = 'currentColor'
export const dlsSidenavItemIconColorDisabled = 'currentColor'
export const dlsSidenavItemIconColorCurrent = 'currentColor'
export const dlsSidenavItemIconColorAux = 'currentColor'
export const dlsSidenavItemIconColorAuxDisabled = 'currentColor'
export const dlsSidenavItemIconColorAuxCurrent = 'currentColor'
export const dlsSidenavItemBackgroundColor = '#fff'
export const dlsSidenavItemBackgroundColorHover = '#f6f7fa'
export const dlsSidenavItemBackgroundColorFocus = '#dce9ff'
export const dlsSidenavItemBackgroundColorActive = '#e2e6f0'
export const dlsSidenavItemBackgroundColorDisabled = '#fff'
export const dlsSidenavItemBackgroundColorCurrent = '#ebf2ff'
export const dlsSidenavItemBackgroundColorCurrentHover = '#dce9ff'
export const dlsSidenavItemBackgroundColorCurrentFocus = '#dce9ff'
export const dlsSidenavItemBackgroundColorCurrentActive = '#bfd7ff'
export const dlsSidenavItemBorderRadius = '4px'
export const dlsSidenavWidth = '200px'
export const dlsSidenavWidthCollapsed = '60px'
export const dlsTagInputPaddingStart = '4px'
export const dlsTagInputTagSpacing = '4px'
export const dlsTagInputTagHeightXs = '16px'
export const dlsTagInputTagHeightS = '20px'
export const dlsTagInputTagHeightM = '24px'
export const dlsTagInputTagHeightL = '28px'
export const dlsSelectWidth = '300px'
export const dlsSelectTagHeightXs = '16px'
export const dlsSelectTagHeightS = '20px'
export const dlsSelectTagHeightM = '24px'
export const dlsSelectTagHeightL = '28px'
export const dlsSelectPaddingX = '12px'
export const dlsSelectPaddingY = '4px'
export const dlsSelectPaddingStart = '4px'
export const dlsSelectContentSpacing = '8px'
export const dlsSelectTagSpacing = '4px'
export const dlsSelectIconSizeAux = 'calc(1em + 2px)'
export const dlsSelectIconColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsSelectIconColorAuxDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsDropdownIconSizeAux = 'calc(1em + 2px)'
export const dlsDropdownIconSpacingAux = '8px'
export const dlsDropdownSplitButtonPaddingX = '12px'
export const dlsDropdownIconColorAuxNormal = 'rgba(73, 86, 107, 0.8)'
export const dlsDropdownIconColorAuxNormalDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsDropdownIconColorAuxPrimary = 'currentColor'
export const dlsDropdownIconColorAuxPrimaryDisabled = 'currentColor'
export const dlsDropdownMaxDisplayItems = '8'
export const dlsDropdownMenuMaxHeightXs = 'calc(24px * var(--dls-dropdown-max-display-items, 8) + 8px)'
export const dlsDropdownMenuMaxHeightS = 'calc(28px * var(--dls-dropdown-max-display-items, 8) + 8px)'
export const dlsDropdownMenuMaxHeightM = 'calc(32px * var(--dls-dropdown-max-display-items, 8) + 8px)'
export const dlsDropdownMenuMaxHeightL = 'calc(36px * var(--dls-dropdown-max-display-items, 8) + 8px)'
export const dlsDropdownMenuBorderRadiusXs = '4px'
export const dlsDropdownMenuBorderRadiusS = '4px'
export const dlsDropdownMenuBorderRadiusM = '4px'
export const dlsDropdownMenuBorderRadiusL = '4px'
export const dlsDropdownMenuTargetSpacing = '4px'
export const dlsDropdownMenuShadow = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsDropdownMenuPlaceholderPaddingY = '8px'
export const dlsDropdownMenuPlaceholderFontColor = 'rgba(73, 86, 107, 0.8)'
export const dlsSliderHeightVertical = '100px'
export const dlsSliderThumbSizeS = '8px'
export const dlsSliderThumbSizeM = '12px'
export const dlsSliderTrackMinWidth = '2px'
export const dlsSliderTrackWidthS = '2px'
export const dlsSliderTrackWidthM = '4px'
export const dlsSliderTrackBorderRadiusS = '1px'
export const dlsSliderTrackBorderRadiusM = '2px'
export const dlsSliderThumbDotMinSize = '2px'
export const dlsSliderThumbDotSizeS = '2px'
export const dlsSliderThumbDotSizeM = '4px'
export const dlsSliderMarkMinSize = '4px'
export const dlsSliderMarkSizeS = '4px'
export const dlsSliderMarkSizeM = '8px'
export const dlsSliderFontSizeS = '12px'
export const dlsSliderFontSizeM = '14px'
export const dlsSliderFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsSliderFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsSliderThumbBackgroundColor = '#0054e6'
export const dlsSliderThumbBackgroundColorHover = '#1a6eff'
export const dlsSliderThumbBackgroundColorFocus = '#1a6eff'
export const dlsSliderThumbBackgroundColorActive = '#0047c4'
export const dlsSliderThumbBackgroundColorReadOnly = '#a8b0bf'
export const dlsSliderThumbBackgroundColorReadOnlyHover = '#848b99'
export const dlsSliderThumbBackgroundColorReadOnlyFocus = '#848b99'
export const dlsSliderThumbBackgroundColorDisabled = '#dce9ff'
export const dlsSliderThumbBorderColorFocus = '#0054e6'
export const dlsSliderThumbBorderColorReadOnlyFocus = '#0054e6'
export const dlsSliderThumbShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsSliderThumbShadowReadOnlyFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsSliderThumbDotColor = '#fff'
export const dlsSliderTrackColor = '#e2e6f0'
export const dlsSliderTrackColorHover = '#d3d9e6'
export const dlsSliderTrackColorReadOnly = '#e2e6f0'
export const dlsSliderTrackColorDisabled = '#e2e6f0'
export const dlsSliderTrackProgressColor = '#0054e6'
export const dlsSliderTrackProgressColorHover = '#1a6eff'
export const dlsSliderTrackProgressColorReadOnly = '#a8b0bf'
export const dlsSliderTrackProgressColorDisabled = '#dce9ff'
export const dlsCollapseHeaderPaddingX = '16px'
export const dlsCollapseHeaderPaddingY = '16px'
export const dlsCollapseHeaderContentSpacing = '8px'
export const dlsCollapseHeaderFontSizeS = '12px'
export const dlsCollapseHeaderFontSizeM = '14px'
export const dlsCollapseHeaderLineHeight = '1.4'
export const dlsCollapseBodyPaddingX = '16px'
export const dlsCollapseBodyPaddingY = '16px'
export const dlsCollapseBodyFontSizeS = '12px'
export const dlsCollapseBodyFontSizeM = '14px'
export const dlsCollapseBodyLineHeight = '1.6'
export const dlsCollapseBorderRadiusS = '4px'
export const dlsCollapseBorderRadiusM = '4px'
export const dlsCollapseIconSizeAux = 'calc(1em + 2px)'
export const dlsCollapseBorderColor = '#e2e6f0'
export const dlsCollapseHeaderFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsCollapseHeaderFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsCollapseHeaderBackgroundColor = '#f6f7fa'
export const dlsCollapseHeaderBackgroundColorHover = '#ebedf5'
export const dlsCollapseHeaderBackgroundColorActive = '#e2e6f0'
export const dlsCollapseHeaderBackgroundColorDisabled = '#f6f7fa'
export const dlsCollapseBodyFontColor = 'rgba(46, 52, 64, 0.9)'
export const dlsCollapseBodyBackgroundColor = '#fff'
export const dlsCollapseIconColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsCollapseIconColorAuxDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsCollapseHeaderBackgroundColorSimple = 'transparent'
export const dlsCollapseHeaderBackgroundColorSimpleHover = 'transparent'
export const dlsCollapseHeaderBackgroundColorSimpleActive = 'transparent'
export const dlsCollapseHeaderBackgroundColorSimpleDisabled = 'transparent'
export const dlsCollapseBodyBackgroundColorSimple = 'transparent'
export const dlsCollapseHeaderBackgroundColorBasic = '#fff'
export const dlsCollapseHeaderBackgroundColorBasicHover = '#f6f7fa'
export const dlsCollapseHeaderBackgroundColorBasicActive = '#e2e6f0'
export const dlsCollapseHeaderBackgroundColorBasicDisabled = '#fff'
export const dlsCollapseBodyBackgroundColorBasic = '#fff'
export const dlsCollapseHeaderBackgroundColorStrong = '#f6f7fa'
export const dlsCollapseHeaderBackgroundColorStrongHover = '#ebedf5'
export const dlsCollapseHeaderBackgroundColorStrongActive = '#e2e6f0'
export const dlsCollapseHeaderBackgroundColorStrongDisabled = '#f6f7fa'
export const dlsCollapseBodyBackgroundColorStrong = '#f6f7fa'
export const dlsCollapseHeaderBorderColorFocus = '#0054e6'
export const dlsCollapseHeaderShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsTooltipMaxWidth = 'calc(16em + 16px)'
export const dlsTooltipFontSize = '12px'
export const dlsTooltipLineHeight = '1.6'
export const dlsTooltipPaddingX = '8px'
export const dlsTooltipPaddingY = '4px'
export const dlsTooltipTargetSpacing = '4px'
export const dlsTooltipArrowWidth = '8px'
export const dlsTooltipArrowSpacing = '8px'
export const dlsTooltipBorderRadius = '4px'
export const dlsTooltipFontColorNormal = 'rgba(13, 15, 18, 0.95)'
export const dlsTooltipBackgroundColorNormal = '#fff'
export const dlsTooltipShadowNormal = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsTooltipFontColorReverse = '#fff'
export const dlsTooltipBackgroundColorReverse = 'rgba(0, 0, 0, 0.6)'
export const dlsTooltipShadowReverse = 'none'
export const dlsPopoverMaxWidth = '400px'
export const dlsPopoverLineHeight = '1.6'
export const dlsPopoverPaddingX = '16px'
export const dlsPopoverPaddingY = '16px'
export const dlsPopoverArrowSpacing = '12px'
export const dlsPopoverBorderRadiusS = '4px'
export const dlsPopoverBorderRadiusM = '4px'
export const dlsPopoverFontSizeS = '12px'
export const dlsPopoverFontSizeM = '14px'
export const dlsPopoverTitleFontWeight = '500'
export const dlsPopoverTitleSpacingS = '4px'
export const dlsPopoverActionSpacingS = '8px'
export const dlsPopoverTitleSpacingM = '8px'
export const dlsPopoverActionSpacingM = '12px'
export const dlsPopoverTitleFontSizeS = '14px'
export const dlsPopoverTitleFontSizeM = '16px'
export const dlsDialogWidthWide = '800px'
export const dlsDialogWidthMedium = '600px'
export const dlsDialogWidthNarrow = '400px'
export const dlsDialogWidthContextual = '400px'
export const dlsDialogBorderRadius = '4px'
export const dlsDialogSpacingY = '20px'
export const dlsDialogMaxHeight = 'calc(100vh - 40px)'
export const dlsDialogPaddingX = '24px'
export const dlsDialogPaddingY = '24px'
export const dlsDialogTitleContentSpacing = '16px'
export const dlsDialogTitleSpacingAfter = '12px'
export const dlsDialogActionSpacingBefore = '20px'
export const dlsDialogActionContentSpacing = '12px'
export const dlsDialogTitleSpacingAfterContextual = '4px'
export const dlsDialogIconSpacingContextual = '12px'
export const dlsDialogIconSizeContextual = 'calc(1em + 2px)'
export const dlsDialogTitleLineHeight = '1.4'
export const dlsDialogBodyLineHeight = '1.8'
export const dlsDialogTitleFontSizeS = '16px'
export const dlsDialogTitleFontSizeM = '18px'
export const dlsDialogBodyFontSizeS = '12px'
export const dlsDialogBodyFontSizeM = '14px'
export const dlsDialogTitleFontWeight = '500'
export const dlsDialogTitleFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsDialogBodyFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsDialogCloseIconSize = 'calc(1em + 2px)'
export const dlsDialogCloseIconSizeFullscreen = 'calc(1em + 2px)'
export const dlsDialogCloseIconMinSize = '10px'
export const dlsDialogIconColorInfo = '#0054e6'
export const dlsDialogIconColorSuccess = '#009940'
export const dlsDialogIconColorWarning = '#ff9448'
export const dlsDialogIconColorError = '#d9150b'
export const dlsDialogBackgroundColor = '#fff'
export const dlsDialogBackdropColor = 'rgba(0, 0, 0, 0.6)'
export const dlsDialogShadow = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsDrawerWidth = '800px'
export const dlsDrawerLevelIndent = '60px'
export const dlsDrawerShadowTop = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsDrawerShadowRight = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsDrawerShadowBottom = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsDrawerShadowLeft = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsDrawerTitleFontSizeS = '16px'
export const dlsDrawerTitleFontSizeM = '18px'
export const dlsDrawerCloseIconSize = 'calc(1em + 2px)'
export const dlsEmbeddedTitleFontSizeS = '16px'
export const dlsEmbeddedTitleFontSizeM = '18px'
export const dlsEmbeddedCloseIconSize = 'calc(1em + 2px)'
export const dlsEmbeddedShadow = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsEmbeddedBorderColor = '#e2e6f0'
export const dlsToastFontSizeS = '12px'
export const dlsToastFontSizeM = '14px'
export const dlsToastBorderRadiusS = '4px'
export const dlsToastBorderRadiusM = '4px'
export const dlsToastLineHeight = '1.8'
export const dlsToastIconSize = 'calc(1em + 2px)'
export const dlsToastIconSizeTitled = 'calc(1em + 2px)'
export const dlsToastIconSizeAux = 'calc(1em + 2px)'
export const dlsToastPaddingX = '16px'
export const dlsToastPaddingY = '8px'
export const dlsToastPaddingYTitled = '16px'
export const dlsToastContentSpacingBefore = '8px'
export const dlsToastContentSpacingAfter = '16px'
export const dlsToastSpacing = '8px'
export const dlsToastMaxWidth = '400px'
export const dlsToastListSpacingBefore = '10vh'
export const dlsToastTitleFontSizeS = '14px'
export const dlsToastTitleFontSizeM = '16px'
export const dlsToastTitleFontWeight = '500'
export const dlsToastTitleLineHeight = '1.4'
export const dlsToastTitleSpacingAfter = '4px'
export const dlsToastBackgroundColor = '#fff'
export const dlsToastFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsToastTitleFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsToastShadow = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsToastIconColorInfo = '#0054e6'
export const dlsToastIconColorSuccess = '#009940'
export const dlsToastIconColorWarning = '#ff9448'
export const dlsToastIconColorError = '#d9150b'
export const dlsAlertFontSizeS = '12px'
export const dlsAlertFontSizeM = '14px'
export const dlsAlertBorderRadiusS = '4px'
export const dlsAlertBorderRadiusM = '4px'
export const dlsAlertLineHeight = '1.6'
export const dlsAlertIconSize = 'calc(1em + 2px)'
export const dlsAlertIconSizeTitled = 'calc(1em + 2px)'
export const dlsAlertIconSizeAux = 'calc(1em + 2px)'
export const dlsAlertPaddingX = '16px'
export const dlsAlertPaddingY = '4px'
export const dlsAlertPaddingYMultiline = '8px'
export const dlsAlertPaddingYTitled = '16px'
export const dlsAlertContentSpacingBefore = '8px'
export const dlsAlertContentSpacingAfter = '16px'
export const dlsAlertTitleFontSizeS = '12px'
export const dlsAlertTitleFontSizeM = '14px'
export const dlsAlertTitleFontWeight = '500'
export const dlsAlertTitleLineHeight = '1.4'
export const dlsAlertTitleSpacingAfter = '4px'
export const dlsAlertFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsAlertTitleFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsAlertBackgroundColorInfo = '#ebf2ff'
export const dlsAlertBackgroundColorSuccess = '#ebfff3'
export const dlsAlertBackgroundColorWarning = '#fff3eb'
export const dlsAlertBackgroundColorError = '#ffeceb'
export const dlsAlertBorderColorInfo = 'transparent'
export const dlsAlertBorderColorSuccess = 'transparent'
export const dlsAlertBorderColorWarning = 'transparent'
export const dlsAlertBorderColorError = 'transparent'
export const dlsAlertIconColorInfo = '#0054e6'
export const dlsAlertIconColorSuccess = '#009940'
export const dlsAlertIconColorWarning = '#ff9448'
export const dlsAlertIconColorError = '#d9150b'
export const dlsAlertPagesSpacing = '4px'
export const dlsAlertPagesFontColor = 'rgba(73, 86, 107, 0.8)'
export const dlsCarouselIndicatorWidth = '12px'
export const dlsCarouselIndicatorWidthCurrent = '36px'
export const dlsCarouselIndicatorHeight = '3px'
export const dlsCarouselIndicatorDotSize = '6px'
export const dlsCarouselIndicatorBorderRadius = '1.5px'
export const dlsCarouselIndicatorSpacingOuter = '12px'
export const dlsCarouselIndicatorSpacingInner = '4px'
export const dlsCarouselIndicatorBackgroundColor = 'rgba(255, 255, 255, 0.3)'
export const dlsCarouselIndicatorBackgroundColorHover = 'rgba(255, 255, 255, 0.4)'
export const dlsCarouselIndicatorBackgroundColorActive = '#fff'
export const dlsCarouselIndicatorBackgroundColorCurrent = '#fff'
export const dlsCarouselIndicatorBackgroundColorOutside = '#ebedf5'
export const dlsCarouselIndicatorBackgroundColorOutsideHover = '#e2e6f0'
export const dlsCarouselIndicatorBackgroundColorOutsideActive = '#d3d9e6'
export const dlsCarouselIndicatorBackgroundColorOutsideCurrent = '#0054e6'
export const dlsCarouselControlSize = '32px'
export const dlsCarouselControlBorderRadius = '50%'
export const dlsCarouselControlShadow = '0 6px 28px 2px rgba(0, 0, 0, 0.04), 0 4px 26px 2px rgba(0, 0, 0, 0.03), 0 2px 24px 1px rgba(0, 0, 0, 0.02)'
export const dlsCarouselControlIconSize = '16px'
export const dlsCarouselControlSpacingInside = '24px'
export const dlsCarouselControlSpacingOutside = '16px'
export const dlsCarouselPagesHeight = '20px'
export const dlsCarouselPagesFontSize = '12px'
export const dlsCarouselPagesFontColor = '#fff'
export const dlsCarouselPagesBackgroundColor = 'rgba(0, 0, 0, 0.6)'
export const dlsCarouselPagesPaddingX = '4px'
export const dlsCarouselPagesBorderRadius = '4px'
export const dlsCarouselSlideGutter = '12px'
export const dlsDatePickerWidth = '160px'
export const dlsDatePickerWidthRange = '248px'
export const dlsDatePickerFontSizeS = '12px'
export const dlsDatePickerFontSizeM = '14px'
export const dlsDatePickerDropdownBackgroundColor = '#fff'
export const dlsDatePickerDropdownBorderRadiusS = '4px'
export const dlsDatePickerDropdownBorderRadiusM = '4px'
export const dlsDatePickerDropdownShadow = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsDatePickerIconColor = 'rgba(73, 86, 107, 0.8)'
export const dlsDatePickerIconColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsDatePickerRangeConnectorPaddingX = '12px'
export const dlsDatePickerRangePanelSpacing = '8px'
export const dlsDatePickerPanelSeparatorColor = '#e2e6f0'
export const dlsDatePickerPanelPaddingX = '16px'
export const dlsDatePickerHeaderPaginationIconSize = 'calc(1em + 2px)'
export const dlsDatePickerHeaderIconSizeAux = 'calc(1em + 2px)'
export const dlsDatePickerHeaderPaddingY = '8px'
export const dlsDatePickerHeaderPaginationSpacing = '12px'
export const dlsDatePickerHeaderIconAuxSpacing = '8px'
export const dlsDatePickerDayBodyPaddingTop = '4px'
export const dlsDatePickerDayBodyPaddingBottom = '12px'
export const dlsDatePickerWeekdaysSpacingAfter = '12px'
export const dlsDatePickerMonthBodyPaddingTop = '24px'
export const dlsDatePickerYearBodyPaddingTop = '24px'
export const dlsDatePickerCellHeightS = '28px'
export const dlsDatePickerCellHeightM = '32px'
export const dlsDatePickerCellWidthS = '28px'
export const dlsDatePickerCellWidthM = '32px'
export const dlsDatePickerCellBorderRadiusS = '4px'
export const dlsDatePickerCellBorderRadiusM = '4px'
export const dlsDatePickerCellShadowFocus = '0 0 0 2px rgba(26, 110, 255, 0.2)'
export const dlsDatePickerCellFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsDatePickerCellFontColorCurrent = '#0054e6'
export const dlsDatePickerCellFontColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsDatePickerCellFontColorDisabled = 'rgba(83, 101, 138, 0.5)'
export const dlsDatePickerCellFontColorSelected = '#fff'
export const dlsDatePickerCellFontWeight = '400'
export const dlsDatePickerCellFontWeightSelected = '500'
export const dlsDatePickerDayCellSpacingY = '4px'
export const dlsDatePickerDayCellSpacingX = '8px'
export const dlsDatePickerMonthCellSpacingY = '20px'
export const dlsDatePickerMonthCellPaddingX = '8px'
export const dlsDatePickerYearCellSpacingY = '20px'
export const dlsDatePickerYearCellPaddingX = '8px'
export const dlsDatePickerCellBackgroundColor = 'transparent'
export const dlsDatePickerCellBackgroundColorHover = '#f6f7fa'
export const dlsDatePickerCellBackgroundColorFocus = '#f6f7fa'
export const dlsDatePickerCellBackgroundColorActive = '#e2e6f0'
export const dlsDatePickerCellBackgroundColorDisabled = '#f6f7fa'
export const dlsDatePickerCellBackgroundColorSelected = '#0054e6'
export const dlsDatePickerCellBackgroundColorSelectedHover = '#1a6eff'
export const dlsDatePickerCellBackgroundColorSelectedFocus = '#1a6eff'
export const dlsDatePickerCellBackgroundColorSelectedActive = '#0047c4'
export const dlsDatePickerCellBackgroundColorAux = 'transparent'
export const dlsDatePickerCellBackgroundColorAuxHover = '#f6f7fa'
export const dlsDatePickerCellBackgroundColorAuxFocus = '#f6f7fa'
export const dlsDatePickerCellBackgroundColorAuxActive = '#e2e6f0'
export const dlsDatePickerCellBackgroundColorRangeEndHover = '#dce9ff'
export const dlsDatePickerCellBackgroundColorRangeEndActive = '#bfd7ff'
export const dlsDatePickerCellBackgroundColorRangeEndFocus = '#dce9ff'
export const dlsDatePickerCellBorderColor = 'transparent'
export const dlsDatePickerCellBorderColorFocus = '#0054e6'
export const dlsDatePickerCellBorderColorRangeEndHover = 'transparent'
export const dlsDatePickerCellBorderColorRangeEndActive = 'transparent'
export const dlsDatePickerListItemHeightM = '32px'
export const dlsDatePickerListItemHeightS = '28px'
export const dlsDatePickerListPaddingY = '8px'
export const dlsDatePickerListItemSpacing = '4px'
export const dlsDatePickerListItemPaddingX = '16px'
export const dlsDatePickerListBackgroundColor = 'transparent'
export const dlsDatePickerListBackgroundColorHover = '#f6f7fa'
export const dlsDatePickerListBackgroundColorFocus = '#f6f7fa'
export const dlsDatePickerListBackgroundColorActive = '#e2e6f0'
export const dlsDatePickerListBackgroundColorSelected = '#ebf2ff'
export const dlsDatePickerListBackgroundColorSelectedHover = '#dce9ff'
export const dlsDatePickerListBackgroundColorSelectedFocus = '#dce9ff'
export const dlsDatePickerListBackgroundColorSelectedActive = '#bfd7ff'
export const dlsDatePickerListFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsDatePickerListFontColorHover = 'rgba(13, 15, 18, 0.95)'
export const dlsDatePickerListFontColorFocus = 'rgba(13, 15, 18, 0.95)'
export const dlsDatePickerListFontColorActive = 'rgba(13, 15, 18, 0.95)'
export const dlsDatePickerListFontColorSelected = '#0054e6'
export const dlsDatePickerListFontColorSelectedHover = '#0054e6'
export const dlsDatePickerListFontColorSelectedFocus = '#0054e6'
export const dlsDatePickerListFontColorSelectedActive = '#0054e6'
export const dlsDatePickerListFontWeight = '400'
export const dlsDatePickerListFontWeightSelected = '500'
export const dlsDatePickerYearScrollerWidth = '80px'
export const dlsUploaderFontSizeS = '12px'
export const dlsUploaderFontSizeM = '14px'
export const dlsUploaderHelperTextSpacingX = '8px'
export const dlsUploaderHelperTextSpacingY = '4px'
export const dlsUploaderHelperTextFontColor = 'rgba(73, 86, 107, 0.8)'
export const dlsUploaderHelperTextMaxWidthMediaS = '160px'
export const dlsUploaderHelperTextMaxWidthMediaM = '320px'
export const dlsUploaderErrorSpacing = '4px'
export const dlsUploaderFileItemSpacingY = '8px'
export const dlsUploaderFileItemPaddingX = '4px'
export const dlsUploaderFileItemPaddingY = '4px'
export const dlsUploaderFileItemLabelSpacing = '4px'
export const dlsUploaderFileItemActionSpacing = '8px'
export const dlsUploaderFileItemWidth = '264px'
export const dlsUploaderFileItemBackgroundColor = 'transparent'
export const dlsUploaderFileItemBackgroundColorHover = '#f6f7fa'
export const dlsUploaderFileItemBackgroundColorError = '#ffeceb'
export const dlsUploaderFileItemBackgroundColorErrorHover = '#ffeceb'
export const dlsUploaderFileItemFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsUploaderFileItemIconColor = 'rgba(13, 15, 18, 0.95)'
export const dlsUploaderForegroundColorError = '#d9150b'
export const dlsUploaderForegroundColorSuccess = '#009940'
export const dlsUploaderMediaBorderColorError = '#d9150b'
export const dlsUploaderMediaHeightM = '160px'
export const dlsUploaderMediaHeightS = '80px'
export const dlsUploaderMediaWidthM = '160px'
export const dlsUploaderMediaWidthS = '80px'
export const dlsUploaderMediaIconSizeM = '40px'
export const dlsUploaderMediaIconSizeS = '24px'
export const dlsUploaderMediaLabelColor = 'rgba(73, 86, 107, 0.8)'
export const dlsUploaderMediaIconColor = 'rgba(73, 86, 107, 0.8)'
export const dlsUploaderMediaPaddingXM = '12px'
export const dlsUploaderMediaPaddingXS = '8px'
export const dlsUploaderMediaContentSpacingM = '4px'
export const dlsUploaderMediaContentSpacingS = '4px'
export const dlsUploaderMaskIconColor = '#fff'
export const dlsUploaderMaskIconSpacing = '12px'
export const dlsUploaderMaskPaddingY = '4px'
export const dlsUploaderMaskPaddingX = '12px'
export const dlsUploaderMaskBackgroundColor = 'rgba(0, 0, 0, 0.6)'
export const dlsUploaderMediaEntrySpacing = '24px'
export const dlsUploaderMediaEntryContentSpacing = '8px'
export const dlsUploaderMediaEntryIconSize = 'calc(1em + 2px)'
export const dlsUploaderMediaSpacingXM = '16px'
export const dlsUploaderMediaSpacingXS = '12px'
export const dlsUploaderMediaSpacingYM = '16px'
export const dlsUploaderMediaSpacingYS = '12px'
export const dlsUploaderMediaPreviewMinWidth = '240px'
export const dlsUploaderMediaPreviewMaxWidth = '480px'
export const dlsTableColumnMinWidth = 'calc(3em + 16px)'
export const dlsTableCellBorderColor = '#ebedf5'
export const dlsTableHeaderBorderColor = '#d3d9e6'
export const dlsTableBorderColorDragging = '#d3d9e6'
export const dlsTablePaddingX = '16px'
export const dlsTableCellPaddingX = '8px'
export const dlsTableCellPaddingY = '12px'
export const dlsTableCellPaddingYCompact = '8px'
export const dlsTableCellPaddingYLoose = '16px'
export const dlsTableCellContentSpacing = '4px'
export const dlsTableCellBackgroundColor = '#fff'
export const dlsTableCellBackgroundColorHover = '#f6f7fa'
export const dlsTableCellFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsTableHeaderPaddingX = '8px'
export const dlsTableHeaderPaddingY = '12px'
export const dlsTableHeaderPaddingYCompact = '8px'
export const dlsTableHeaderPaddingYLoose = '16px'
export const dlsTableHeaderBackgroundColor = '#ebedf5'
export const dlsTableHeaderBackgroundColorHover = '#e2e6f0'
export const dlsTableHeaderFontWeight = '500'
export const dlsTableHeaderFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsTableSubRowBackgroundColor = '#f6f7fa'
export const dlsTableSubRowBackgroundColorHover = '#ebedf5'
export const dlsTableFontSizeS = '12px'
export const dlsTableFontSizeM = '14px'
export const dlsTableBorderRadiusS = '4px'
export const dlsTableBorderRadiusM = '4px'
export const dlsTableIconSize = 'calc(1em + 2px)'
export const dlsTableIconSizeAux = 'calc(1em + 2px)'
export const dlsTableHeaderIconColor = 'rgba(83, 101, 138, 0.5)'
export const dlsTableHeaderIconColorHover = 'rgba(73, 86, 107, 0.8)'
export const dlsTableHeaderIconColorActive = 'rgba(46, 52, 64, 0.9)'
export const dlsTableHeaderIconColorDisabled = 'rgba(102, 146, 222, 0.15)'
export const dlsTableOverflowShadowTop = 'none'
export const dlsTableOverflowShadowRight = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsTableOverflowShadowBottom = 'none'
export const dlsTableOverflowShadowLeft = '0 1px 8px rgba(0, 0, 0, 0.06), 0 7px 14px 2px rgba(0, 0, 0, 0.05), 0 8px 16px 4px rgba(0, 0, 0, 0.04)'
export const dlsTableBodyHeightNoData = '108px'
export const dlsTableActionSpacing = '16px'
export const dlsTableFilterActionPaddingY = '16px'
export const dlsTableFilterActionSpacing = '16px'
export const dlsFormLabelSpacingAfterHorizontal = '24px'
export const dlsFormLabelSpacingAfterVertical = '8px'
export const dlsFormLabelContentSpacing = '4px'
export const dlsFormLabelWidth = '7em'
export const dlsFormLabelFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsFormLabelIconColor = 'rgba(73, 86, 107, 0.8)'
export const dlsFormLabelRequiredColor = '#d9150b'
export const dlsFormFieldSpacingVertical = '24px'
export const dlsFormFieldErrorFontColor = '#d9150b'
export const dlsFormFieldErrorSpacingBeforeVertical = '4px'
export const dlsFormActionsSpacingBefore = '40px'
export const dlsFormActionsContentSpacing = '20px'
export const dlsFormFieldHelpSpacing = '8px'
export const dlsLightboxPaddingX = '24px'
export const dlsLightboxPaddingY = '40px'
export const dlsLightboxContentSpacingY = '24px'
export const dlsLightboxContentSpacingX = '24px'
export const dlsLightboxBackdropColor = 'rgba(0, 0, 0, 0.6)'
export const dlsLightboxFontColor = '#fff'
export const dlsLightboxFontSize = '14px'
export const dlsLightboxCloseIconSize = '24px'
export const dlsLightboxControlSize = '48px'
export const dlsLightboxControlBorderRadius = '50%'
export const dlsLightboxControlIconSize = '24px'
export const dlsCascaderColumnMinWidth = '120px'
export const dlsCascaderOptionPaddingXs = '12px'
export const dlsCascaderOptionPaddingS = '12px'
export const dlsCascaderOptionPaddingM = '12px'
export const dlsCascaderOptionPaddingL = '12px'
export const dlsCascaderHeaderPaddingY = '8px'
export const dlsCascaderFooterPaddingY = '8px'
export const dlsAccordionDefaultGutter = '16px'
export const dlsLayoutMinWidth = '1248px'
export const dlsLayoutBackgroundColor = '#f6f7fa'
export const dlsLayoutHeaderHeight = '64px'
export const dlsLayoutHeaderBackgroundColor = '#fff'
export const dlsLayoutHeaderShadow = '0 4px 10px rgba(0, 0, 0, 0.03), 0 3px 9px rgba(0, 0, 0, 0.02), 0 2px 8px rgba(0, 0, 0, 0.01)'
export const dlsLayoutSidebarBackgroundColor = '#fff'
export const dlsLayoutSidebarWidth = '200px'
export const dlsLayoutSidebarWidthSlim = '60px'
export const dlsLayoutSidebarShadow = '0 4px 10px rgba(0, 0, 0, 0.03), 0 3px 9px rgba(0, 0, 0, 0.02), 0 2px 8px rgba(0, 0, 0, 0.01)'
export const dlsLayoutSidebarSeparatorColor = '#e2e6f0'
export const dlsLayoutSidebarToggleHeight = '40px'
export const dlsLayoutSidebarTogglePaddingX = '8px'
export const dlsLayoutSidebarFloatToggleWidth = '18px'
export const dlsLayoutSidebarFloatToggleRadius = '4px'
export const dlsLayoutSidebarFloatButtonFontColor = '#fff'
export const dlsLayoutSidebarFloatToggleBackgroudColor = '#a8b0bf'
export const dlsLayoutSidebarFloatToggleBackgroudColorHover = '#848b99'
export const dlsLayoutSidebarFloatToggleBackgroudColorActive = '#545b66'
export const dlsLayoutFooterHeight = '64px'
export const dlsMessageFontSizeS = '12px'
export const dlsMessageFontSizeM = '14px'
export const dlsMessageIconSize = 'calc(1em + 2px)'
export const dlsMessageLineHeight = '1.4'
export const dlsMessageContentSpacing = '4px'
export const dlsMessageFontColorStandalone = 'rgba(13, 15, 18, 0.95)'
export const dlsMessageFontColorInfo = 'rgba(13, 15, 18, 0.95)'
export const dlsMessageFontColorSuccess = '#009940'
export const dlsMessageFontColorWarning = '#ff9448'
export const dlsMessageFontColorError = '#d9150b'
export const dlsMessageFontColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsMessageIconColorInfo = '#0054e6'
export const dlsMessageIconColorSuccess = '#009940'
export const dlsMessageIconColorWarning = '#ff9448'
export const dlsMessageIconColorError = '#d9150b'
export const dlsMessageIconColorAux = 'rgba(73, 86, 107, 0.8)'
export const dlsEmptyMaxWidthS = '240px'
export const dlsEmptyMaxWidthM = '320px'
export const dlsEmptyImageMaxHeightS = '48px'
export const dlsEmptyImageMaxHeightM = 'none'
export const dlsEmptyTitleFontSizeS = '12px'
export const dlsEmptyTitleFontSizeM = '14px'
export const dlsEmptyTitleLineHeight = '1.4'
export const dlsEmptyTitleFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsEmptyTitleFontWeight = '500'
export const dlsEmptyDescFontSizeS = '12px'
export const dlsEmptyDescFontSizeM = '14px'
export const dlsEmptyDescLineHeight = '1.4'
export const dlsEmptyDescFontColor = 'rgba(46, 52, 64, 0.9)'
export const dlsEmptyDescFontWeight = '400'
export const dlsEmptyContentSpacing = '8px'
export const dlsEmptyActionsSpacingBefore = '16px'
export const dlsEmptyActionsContentSpacing = '8px'
export const dlsScrollbarTrackWidth = '10px'
export const dlsScrollbarTrackColor = 'transparent'
export const dlsScrollbarThumbWidth = '6px'
export const dlsScrollbarThumbColor = 'rgba(96, 134, 199, 0.2)'
export const dlsScrollbarThumbColorHover = 'rgba(83, 101, 138, 0.5)'
export const dlsScrollbarThumbBorderRadius = '3px'
export const dlsRatingSymbolColor = '#d3d9e6'
export const dlsRatingSymbolColorSelected = '#ff9448'
export const dlsRatingSymbolGap = 'var(--dls-rating-symbol-gap, 2px)'
export const dlsRatingSymbolSize = '14px'
export const dlsRatingSymbolScaleHover = '1.1'
export const dlsRatingLabelSpacing = 'var(--dls-rating-label-spacing, 16px)'
export const dlsRatingLabelFontColor = 'rgba(13, 15, 18, 0.95)'
export const dlsRatingLabelFontSize = '14px'
